// fr strings. Every key must exist in all four tables (npm run check:i18n).
export default {
  "nav.overview": "Accueil",
  "nav.domains": "Domaines",
  "nav.hosting": "Hébergement",
  "nav.email": "E-mail",
  "nav.backups": "Sauvegardes",
  "nav.billing": "Facturation",
  "nav.account": "Compte",
  "dash.subtitle": "Voici en un coup d’œil l’état de vos services.",
  "status.allgood": "Tout fonctionne",
  "status.attention": "Attention requise",
  "qa.title": "Actions rapides",
  "qa.domain": "Ajouter un domaine",
  "qa.domain.d": "Enregistrer ou transférer",
  "qa.mailbox": "Créer une boîte mail",
  "qa.mailbox.d": "Nouvelle adresse e-mail",
  "qa.dns": "Enregistrement DNS",
  "qa.dns.d": "Pointer ou modifier",
  "qa.restore": "Restaurer une sauvegarde",
  "qa.restore.d": "Revenir à un état antérieur",
  "svc.title": "Mes sites web",
  "svc.viewall": "Tout afficher",
  "svc.package": "Formule",
  "svc.mailboxes": "Boîtes mail",
  "svc.backup": "Dernière sauvegarde",
  "svc.manage": "Gérer",
  "svc.expires": "Prochaine facture",
  "use.title": "Utilisation",
  "use.disk": "Stockage",
  "use.traffic": "Trafic",
  "use.mail": "Stockage e-mail",
  "use.of": "sur",
  "act.title": "Activité récente",
  "act.viewall": "Tout afficher",
  "next.invoice.title": "Vous avez une facture en attente",
  "next.invoices.title": "Vous avez des factures en attente",
  "next.invoice.body": "Total impayé\u00a0: {amount}.",
  "next.overdue.body": "Total impayé\u00a0: {amount}. Une facture a dépassé sa date d’échéance.",
  "next.invoice.cta": "Voir les factures",
  "status.loading": "Vérification de l’état…",
  "status.attention.n": "{n} services requièrent votre attention",
  "status.attention.1": "1 service requiert votre attention",
  "err.network": "Impossible de joindre le serveur. Vérifiez votre connexion Internet et réessayez.",
  "err.401": "Votre session a expiré. Veuillez vous reconnecter.",
  "err.login.401": "Adresse e-mail ou mot de passe incorrect.",
  "err.login.mfa": "Code 2FA invalide ou expiré.",
  "err.403": "Vous n’avez pas accès à cette section.",
  "err.404": "Introuvable. L’élément a peut-être été supprimé ou n’appartient pas à votre compte.",
  "err.409": "Cet élément existe déjà ou entre en conflit avec un paramètre existant.",
  "err.code.quota_exceeded": "Pas assez d'espace : {quota_mb} Mo ne tiennent pas, il reste {left_mb} Mo sur {domain}.",
  "err.422": "Certains champs ne sont pas remplis correctement.",
  "err.429": "Trop de tentatives. Patientez une minute et réessayez.",
  "err.5xx": "Un problème est survenu de notre côté. Veuillez réessayer plus tard.",
  "err.generic": "Une erreur s’est produite. Veuillez réessayer.",
  "common.everything_ok": "Tout fonctionne correctement",
  "dom.title": "Domaines",
  "dom.sub": "Gérez tous vos noms de domaine, le DNS et les redirections en un seul endroit.",
  "dom.add": "Ajouter un domaine",
  "dom.search": "Rechercher un domaine…",
  "dom.filter.all": "Tous",
  "dom.filter.active": "Actifs",
  "dom.filter.expiring": "Expire bientôt",
  "dom.filter.transfer": "En transfert",
  "dom.col.domain": "Domaine",
  "dom.col.linked": "Lié à",
  "dom.col.expires": "Expire",
  "dom.col.autorenew": "Renouv. auto",
  "dom.col.status": "Statut",
  "dom.linked.hosting": "Hébergement",
  "dom.linked.forward": "Redirection",
  "dom.linked.parked": "Parqué",
  "dom.status.active": "Actif",
  "dom.status.expiring": "Expire dans {n} jours",
  "dom.status.transfer": "Transfert",
  "dom.add.title": "Quel domaine souhaitez-vous\u00a0?",
  "dom.add.placeholder": "p. ex. monentreprise",
  "dom.add.btn": "Vérifier la disponibilité",
  "dom.add.transfer": "Transférer un domaine existant",
  "dd.back": "Tous les domaines",
  "dd.tab.overview": "Vue d’ensemble",
  "dd.tab.dns": "DNS",
  "dd.tab.email": "Routage des e-mails",
  "dd.tab.forward": "Redirection",
  "dd.tab.settings": "Paramètres",
  "dd.owner": "Titulaire",
  "dd.registered": "Enregistré",
  "dd.expires": "Expire le",
  "dd.renew": "Renouveler maintenant",
  "dd.autorenew": "Renouvellement automatique",
  "dd.autorenew.short": "Renouv. auto",
  "common.yes": "Oui",
  "common.no": "Non",
  "ar.off.title": "Désactiver le renouvellement automatique\u00a0?",
  "ar.off.body": "Voulez-vous vraiment ne pas renouveler ce domaine\u00a0? Il sera résilié et ne sera plus accessible après la date d’expiration.",
  "ar.off.meta": "Expire le",
  "ar.off.warning": "Après la date d’expiration, le domaine pourra être enregistré par quelqu’un d’autre.",
  "ar.off.cancel": "Annuler, continuer le renouvellement",
  "ar.off.confirm": "Oui, résilier",
  "host.title": "Hébergement",
  "host.sub": "Vos formules d’hébergement, avec caractéristiques et consommation en un seul endroit.",
  "host.new": "Nouvelle formule",
  "host.kpi.sites": "Sites web actifs",
  "host.kpi.storage": "Stockage utilisé",
  "host.kpi.traffic": "Trafic ce mois-ci",
  "host.banner.title": "PHP 8.3 est prêt pour deux de vos sites",
  "host.banner.body": "Nous avons déjà testé la mise à niveau sur une copie de préproduction. Vous pouvez la planifier en un clic à un moment calme.",
  "host.banner.cta": "Planifier la mise à niveau",
  "host.pkg.title": "Formules",
  "host.pkg.online": "En ligne",
  "host.spec.server": "Serveur",
  "host.spec.php": "PHP",
  "host.spec.ssl": "SSL",
  "host.spec.mailboxes": "Boîtes mail",
  "host.spec.lastbackup": "Dernière sauvegarde",
  "host.usage.storage": "Stockage",
  "host.usage.traffic": "Trafic",
  "host.usage.db": "Base de données",
  "host.manage": "Gérer",
  "host.upgrade": "Changer de formule",
  "host.ssl.valid": "Valide jusqu’au",
  "host.ssl.auto": "Renouvellement automatique",
  "host.tools.title": "Outils rapides",
  "host.tools.files": "Gestionnaire de fichiers",
  "host.tools.files.d": "Envoi par FTP ou en ligne",
  "host.tools.db": "Base de données",
  "host.tools.db.d": "MySQL · phpMyAdmin",
  "host.tools.ssh": "Accès SSH",
  "host.tools.ssh.d": "Gérez vos clés",
  "host.tools.cron": "Tâches cron",
  "host.tools.cron.d": "Planifier des tâches périodiques",
  "host.server.title": "Serveurs",
  "host.server.uptime": "Disponibilité 30 jours",
  "host.server.location": "Eemshaven, NL",
  "host.summary.title": "Consommation totale",
  "host.summary.sub": "Toutes formules confondues, ce mois-ci.",
  "hd.back": "Toutes les formules",
  "hd.tab.overview": "Vue d’ensemble",
  "hd.tab.files": "Fichiers",
  "hd.tab.db": "Base de données",
  "hd.tab.ssh": "SSH",
  "hd.tab.cron": "Tâches cron",
  "hd.tab.settings": "Paramètres",
  "hd.kpi.uptime": "Disponibilité 30 jours",
  "hd.kpi.requests": "Requêtes aujourd’hui",
  "hd.kpi.errors": "Erreurs (24 h)",
  "hd.kpi.response": "Temps de réponse moy.",
  "hd.deploys": "Déploiements récents",
  "hd.deploys.empty": "Aucun déploiement pour l’instant.",
  "hd.access": "Informations d’accès",
  "hd.access.ftp": "FTP / SFTP",
  "hd.access.ssh": "SSH",
  "hd.access.user": "Utilisateur",
  "hd.access.host": "Hôte",
  "hd.access.port": "Port",
  "hd.access.path": "Racine web",
  "hd.files.upload": "Envoyer",
  "hd.files.new_folder": "Nouveau dossier",
  "hd.files.search": "Rechercher des fichiers…",
  "hd.files.col.name": "Nom",
  "hd.files.col.size": "Taille",
  "hd.files.col.modified": "Modifié",
  "hd.db.create": "Nouvelle base de données",
  "hd.db.open": "Ouvrir dans phpMyAdmin",
  "hd.db.col.name": "Base de données",
  "hd.db.col.size": "Taille",
  "hd.db.col.users": "Utilisateurs",
  "hd.db.col.engine": "Moteur",
  "hd.ssh.cred": "Informations de connexion",
  "hd.ssh.keys": "Clés autorisées",
  "hd.ssh.addkey": "Ajouter une clé",
  "hd.ssh.copy": "Copier la commande",
  "hd.ssh.key.added": "Ajoutée",
  "hd.cron.add": "Ajouter une tâche cron",
  "hd.cron.col.schedule": "Planification",
  "hd.cron.col.cmd": "Commande",
  "hd.cron.col.last": "Dernière exécution",
  "hd.cron.col.status": "Statut",
  "hd.set.php.title": "Version de PHP",
  "hd.set.php.sub": "Choisissez la version de PHP pour cette formule. Les modifications s’appliquent immédiatement à tout le site.",
  "hd.set.php.apply": "Appliquer la version",
  "hd.set.restart.title": "Redémarrer la formule",
  "hd.set.restart.sub": "Indisponible temporairement (~30 s). À utiliser uniquement si le site est bloqué.",
  "hd.set.restart.cta": "Redémarrer maintenant",
  "hd.set.danger.title": "Résilier la formule",
  "hd.set.danger.sub": "Supprime cette formule et tous ses fichiers. Action irréversible.",
  "hd.set.danger.cta": "Résilier la formule",
  "hp.new.title": "Nouvelle formule d’hébergement",
  "hp.new.sub": "Choisissez une formule. Vous pourrez évoluer plus tard sans interruption.",
  "hp.new.month": "par mois",
  "hp.new.choose": "Choisir cette formule",
  "hp.new.popular": "Populaire",
  "hp.new.feat.storage": "de stockage",
  "hp.new.feat.traffic": "de trafic",
  "hp.new.feat.mail": "boîtes mail",
  "hp.new.feat.db": "bases de données",
  "hp.new.feat.ssl": "SSL inclus",
  "hp.new.feat.backup": "Sauvegardes quotidiennes",
  "hp.new.feat.ssh": "Accès SSH",
  "hp.new.feat.staging": "Environnement de préproduction",
  "ht.scope": "Pour",
  "ht.files.title": "Gestionnaire de fichiers",
  "ht.files.sub": "Envoyez et gérez les fichiers de cette formule.",
  "ht.db.title": "Bases de données",
  "ht.db.sub": "Bases de données MySQL de cette formule.",
  "ht.ssh.title": "Accès SSH",
  "ht.ssh.sub": "Gérez les clés autorisées et les paramètres de connexion.",
  "ht.cron.title": "Tâches cron",
  "ht.cron.sub": "Planifiez des tâches récurrentes exécutées sur le serveur.",
  "act.download": "Télécharger",
  "act.rename": "Renommer",
  "act.move": "Déplacer",
  "act.permissions": "Permissions",
  "act.delete": "Supprimer",
  "act.open": "Ouvrir dans phpMyAdmin",
  "act.export": "Exporter (dump SQL)",
  "act.import": "Importer un dump",
  "act.users": "Gérer les utilisateurs",
  "act.copy_pub": "Copier la clé publique",
  "act.revoke": "Révoquer la clé",
  "act.run_now": "Exécuter maintenant",
  "act.edit": "Modifier",
  "act.view_logs": "Voir les journaux",
  "act.pause": "Suspendre",
  "act.resume": "Reprendre",
  "act.duplicate": "Dupliquer",
  "act.more": "Plus d’actions",
  "g.cancel": "Annuler",
  "g.save": "Enregistrer",
  "g.apply": "Appliquer",
  "g.confirm": "Confirmer",
  "mod.rename.title": "Renommer",
  "mod.rename.label": "Nouveau nom",
  "mod.rename.save": "Renommer",
  "mod.move.title": "Déplacer",
  "mod.move.sub": "Choisissez le dossier de destination. Les fichiers sont déplacés immédiatement.",
  "mod.move.current": "Emplacement actuel",
  "mod.move.target": "Dossier de destination",
  "mod.move.save": "Déplacer",
  "mod.perm.title": "Permissions",
  "mod.perm.sub": "Choisissez qui peut faire quoi avec ce fichier. Appliqué immédiatement.",
  "mod.perm.owner": "Propriétaire",
  "mod.perm.group": "Groupe",
  "mod.perm.public": "Tout le monde",
  "mod.perm.read": "Lecture",
  "mod.perm.write": "Écriture",
  "mod.perm.exec": "Exécution",
  "mod.perm.octal": "Valeur octale",
  "mod.delfile.title.file": "Supprimer le fichier\u00a0?",
  "mod.delfile.title.dir": "Supprimer le dossier\u00a0?",
  "mod.delfile.body.file": "Ce fichier sera définitivement supprimé. Cette action est irréversible.",
  "mod.delfile.body.dir": "Ce dossier et tout son contenu seront définitivement supprimés. Cette action est irréversible.",
  "mod.delfile.cta": "Oui, supprimer",
  "mod.deldb.title": "Supprimer la base de données\u00a0?",
  "mod.deldb.body": "Toutes les données, tables et utilisateurs seront perdus. Cette action est irréversible.",
  "mod.deldb.confirm": "Saisissez le nom de la base de données pour confirmer",
  "mod.deldb.cta": "Supprimer la base de données",
  "mod.exp.title": "Exporter",
  "mod.exp.sub": "Créez un dump à importer plus tard ou à conserver comme sauvegarde.",
  "mod.exp.format": "Format",
  "mod.exp.compress": "Compresser (.gz)",
  "mod.exp.tables": "Tables",
  "mod.exp.tables.all": "Toutes les tables",
  "mod.exp.tables.pick": "Sélectionner des tables",
  "mod.exp.structure": "Structure",
  "mod.exp.data": "Données",
  "mod.exp.start": "Lancer l’export",
  "mod.imp.title": "Importer un dump",
  "mod.imp.sub": "Envoyez un fichier .sql ou .sql.gz. Les tables existantes seront écrasées.",
  "mod.imp.drop": "Glissez un fichier ici ou cliquez pour en choisir un",
  "mod.imp.replace": "Écraser les tables existantes",
  "mod.imp.start": "Lancer l’import",
  "mod.imp.warn": "Un import écrase les données. Faites d’abord un export comme sauvegarde.",
  "mod.dbu.title": "Utilisateurs",
  "mod.dbu.sub": "Gérez les utilisateurs ayant accès à cette base de données.",
  "mod.dbu.add": "Ajouter un utilisateur",
  "mod.dbu.user": "Utilisateur",
  "mod.dbu.host": "Hôte",
  "mod.dbu.priv": "Privilèges",
  "mod.dbu.priv.ro": "Lecture seule",
  "mod.dbu.priv.rw": "Lecture et écriture",
  "mod.dbu.priv.full": "Accès complet",
  "mod.dbu.new.user": "Nom d’utilisateur",
  "mod.dbu.new.pwd": "Mot de passe",
  "mod.dbu.new.pwd.gen": "Générer",
  "mod.dbu.remove": "Retirer",
  "mod.revk.title": "Révoquer la clé\u00a0?",
  "mod.revk.body": "Une fois révoquée, cette clé ne pourra plus se connecter au serveur. Les connexions existantes restent actives jusqu’à leur fermeture.",
  "mod.revk.cta": "Oui, révoquer",
  "mod.cron.title.edit": "Modifier la tâche cron",
  "mod.cron.title.new": "Nouvelle tâche cron",
  "mod.cron.preset": "Planification",
  "mod.cron.preset.5min": "Toutes les 5 minutes",
  "mod.cron.preset.hour": "Toutes les heures",
  "mod.cron.preset.day": "Chaque nuit à 03:00",
  "mod.cron.preset.week": "Chaque semaine, dim. 02:00",
  "mod.cron.preset.custom": "Planification personnalisée",
  "mod.cron.schedule": "Expression cron",
  "mod.cron.cmd": "Commande",
  "mod.cron.next": "Prochaine exécution",
  "mod.clog.title": "Journaux",
  "mod.clog.sub": "30 dernières lignes de cette tâche cron.",
  "mod.cdel.title": "Supprimer la tâche cron\u00a0?",
  "mod.cdel.body": "Cette tâche ne sera plus exécutée après confirmation. Cette action est irréversible.",
  "tst.download": "Téléchargement lancé",
  "tst.copied": "Copié dans le presse-papiers",
  "tst.renamed": "Renommé",
  "tst.moved": "Déplacé",
  "tst.perm_set": "Permissions mises à jour",
  "tst.deleted": "Supprimé",
  "tst.exported": "Export programmé",
  "tst.imported": "Import lancé",
  "tst.user_added": "Utilisateur ajouté",
  "tst.user_removed": "Utilisateur retiré",
  "tst.priv_changed": "Privilèges mis à jour",
  "tst.key_revoked": "Clé révoquée",
  "tst.cron_run": "Tâche cron lancée",
  "tst.cron_duped": "Tâche cron dupliquée",
  "tst.cron_paused": "Tâche cron mise en pause",
  "tst.cron_resumed": "Tâche cron reprise",
  "tst.cron_saved": "Tâche cron enregistrée",
  "tst.cron_deleted": "Tâche cron supprimée",
  "tst.phpmyadmin": "Ouverture de phpMyAdmin dans un nouvel onglet…",
  "mod.newdir.title": "Nouveau dossier",
  "mod.newdir.label": "Nom du dossier",
  "mod.newdir.cta": "Créer",
  "tst.created": "Créé",
  "mod.newdb.title": "Nouvelle base de données",
  "mod.newdb.sub": "Donnez un nom à la base de données. Utilisez des tirets bas au lieu d’espaces.",
  "mod.newdb.label": "Nom",
  "mod.newdb.cta": "Créer la base de données",
  "mod.upload.title": "Importer des fichiers",
  "mod.upload.sub": "Faites glisser des fichiers ici ou cliquez pour les sélectionner.",
  "mod.upload.target": "Dossier de destination",
  "mod.upload.start": "Lancer l’import",
  "mod.upload.drop": "Faites glisser des fichiers ici ou cliquez pour les sélectionner",
  "tst.uploading": "Import lancé",
  "mod.addkey.title": "Ajouter une clé SSH",
  "mod.addkey.sub": "Collez votre clé publique (commence par ssh-rsa, ssh-ed25519, …).",
  "mod.addkey.label": "Nom",
  "mod.addkey.label.placeholder": "p. ex. Portable professionnel",
  "mod.addkey.key": "Clé publique",
  "mod.addkey.cta": "Ajouter la clé",
  "tst.key_added": "Clé ajoutée",
  "mod.upgrade.title": "Passer à une formule supérieure",
  "mod.upgrade.sub": "Choisissez une formule supérieure. La mise à niveau est immédiate, sans interruption.",
  "mod.upgrade.current": "Formule actuelle",
  "mod.upgrade.cta": "Mettre à niveau",
  "tst.upgraded": "Formule mise à jour",
  "mod.restart.body": "Le site va redémarrer et sera inaccessible pendant environ 30 secondes.",
  "mod.restart.cta": "Oui, redémarrer",
  "tst.restarting": "Redémarrage lancé…",
  "mod.canplan.body": "La formule ainsi que tous les fichiers, bases de données et e-mails seront supprimés. Cette action est irréversible.",
  "mod.canplan.confirm": "Saisissez le domaine pour confirmer",
  "tst.canceled": "Formule résiliée",
  "mod.phpup.title": "Planifier la mise à niveau vers PHP 8.3",
  "mod.phpup.sub": "Choisissez quand effectuer la mise à niveau. Pendant celle-ci, votre site est inaccessible pendant ~10 secondes.",
  "mod.phpup.when": "Quand",
  "mod.phpup.when.now": "Exécuter maintenant",
  "mod.phpup.when.tonight": "Cette nuit à 03:00",
  "mod.phpup.when.weekend": "Ce week-end",
  "mod.phpup.sites": "Sites concernés par la mise à niveau",
  "mod.phpup.cta": "Planifier la mise à niveau",
  "tst.upgrade_scheduled": "Mise à niveau planifiée",
  "tst.php_applied": "Version PHP appliquée",
  "em.title": "E-mail",
  "em.sub": "Gérez vos boîtes mail, alias, transferts et filtres anti-spam.",
  "em.new": "Nouvelle adresse",
  "em.new.mailbox": "Boîte mail",
  "em.new.alias": "Alias",
  "em.new.forward": "Transfert",
  "em.new.catchall": "Catch-all",
  "em.new.mailbox.d": "Véritable boîte de réception avec accès IMAP/SMTP.",
  "em.new.alias.d": "Adresse supplémentaire qui arrive dans une boîte mail existante.",
  "em.new.forward.d": "Transférer les e-mails vers une adresse externe.",
  "em.new.catchall.d": "Recevoir tous les e-mails de ce domaine au même endroit.",
  "em.new.helper": "Que souhaitez-vous créer\u00a0?",
  "em.new.target": "Distribuer dans",
  "em.new.forward_to": "Transférer vers",
  "em.search": "Rechercher une boîte mail ou un alias…",
  "em.filter.all": "Tous",
  "em.filter.mailbox": "Boîtes mail",
  "em.filter.alias": "Alias",
  "em.filter.forward": "Transferts",
  "em.kpi.mailboxes": "Boîtes mail actives",
  "em.kpi.storage": "Stockage e-mail",
  "em.kpi.spam": "Spam bloqué (24 h)",
  "em.kpi.delivered": "Distribués aujourd’hui",
  "em.col.address": "Adresse",
  "em.col.type": "Type",
  "em.col.usage": "Utilisation",
  "em.col.last": "Dernière connexion",
  "em.col.status": "Statut",
  "em.type.mailbox": "Boîte mail",
  "em.type.alias": "Alias",
  "em.type.forward": "Transfert",
  "em.type.catchall": "Catch-all",
  "em.status.active": "Active",
  "em.status.full": "Presque pleine",
  "em.status.vacation": "Absent",
  "em.status.paused": "En pause",
  "em.group.by_domain": "Par domaine",
  "em.group.flat": "Liste simple",
  "em.banner.title": "La protection anti-spam est active",
  "em.banner.body": "Nous avons bloqué 1 284 messages pour vos domaines cette semaine. Aucune action requise.",
  "em.banner.cta": "Paramètres anti-spam",
  "ed.back": "Toutes les boîtes mail",
  "ed.tab.overview": "Vue d’ensemble",
  "ed.tab.filters": "Filtres",
  "ed.tab.forward": "Transfert",
  "ed.tab.vacation": "Absence",
  "ed.tab.aliases": "Alias",
  "ed.tab.settings": "Paramètres",
  "ed.kpi.in": "Reçus aujourd’hui",
  "ed.kpi.out": "Envoyés aujourd’hui",
  "ed.kpi.spam": "Spam",
  "ed.kpi.bounce": "Rebonds",
  "ed.webmail": "Ouvrir le webmail",
  "ed.changepwd": "Modifier le mot de passe",
  "ed.access.title": "Informations d’accès",
  "ed.access.imap": "IMAP",
  "ed.access.smtp": "SMTP",
  "ed.access.host": "Hôte",
  "ed.access.port": "Port",
  "ed.access.user": "Utilisateur",
  "ed.access.security": "Sécurité",
  "ed.recent.title": "Activité récente",
  "ed.recent.empty": "Aucune activité au cours des 7 derniers jours.",
  "ed.devices.title": "Appareils connectés",
  "ed.devices.logout": "Déconnecter",
  "ef.title": "Filtres",
  "ef.sub": "Déplacer, marquer ou supprimer automatiquement des messages.",
  "ef.add": "Ajouter un filtre",
  "ef.col.name": "Nom",
  "ef.col.when": "Quand",
  "ef.col.then": "Action",
  "ef.empty.title": "Aucun filtre pour l’instant",
  "ef.empty.sub": "Créez votre premier filtre, p. ex.\u00a0: déplacer tout ce qui vient de bookings@ dans le dossier Réservations.",
  "ef.cond.from": "L’expéditeur contient",
  "ef.cond.subject": "L’objet contient",
  "ef.cond.to": "Le destinataire contient",
  "ef.cond.body": "Le message contient",
  "ef.act.folder": "Déplacer vers le dossier",
  "ef.act.label": "Ajouter une étiquette",
  "ef.act.flag": "Marquer comme important",
  "ef.act.delete": "Supprimer immédiatement",
  "ef.act.forward": "Transférer vers",
  "evf.title": "Transfert",
  "evf.sub": "Transférer automatiquement les e-mails entrants vers une autre adresse.",
  "evf.on": "Transfert activé",
  "evf.to": "Vers",
  "evf.keep": "Conserver une copie dans cette boîte mail",
  "evf.add_to": "Ajouter une adresse",
  "evf.empty": "Ajoutez au moins une adresse de transfert.",
  "ev.title": "Réponse automatique",
  "ev.sub": "Envoyez une réponse automatique lorsque vous n’êtes pas disponible.",
  "ev.on": "Réponse automatique activée",
  "ev.from": "Du",
  "ev.until": "Au",
  "ev.subject": "Objet",
  "ev.message": "Message",
  "ev.once": "Une fois par expéditeur",
  "ea.title": "Alias",
  "ea.sub": "Adresses supplémentaires qui arrivent dans cette boîte mail.",
  "ea.add": "Ajouter un alias",
  "ea.col.alias": "Alias",
  "ea.col.target": "Arrive dans",
  "ea.empty.title": "Aucun alias",
  "ea.empty.sub": "Créez par exemple info@ ou contact@ comme alias de cette boîte mail.",
  "es.title": "Paramètres",
  "es.quota.title": "Quota de stockage",
  "es.quota.sub": "Taille maximale de cette boîte mail.",
  "es.spam.title": "Filtre anti-spam",
  "es.spam.sub": "Définissez le niveau de filtrage du spam.",
  "es.spam.strict": "Strict",
  "es.spam.balanced": "Équilibré",
  "es.spam.lenient": "Souple",
  "es.smtp.title": "Autoriser le SMTP externe",
  "es.smtp.sub": "Envoyer via cette boîte mail depuis des appareils externes.",
  "es.danger.title": "Supprimer la boîte mail",
  "es.danger.sub": "Supprimer cette boîte mail et tous ses messages. Action irréversible.",
  "es.danger.cta": "Supprimer la boîte mail",
  "mod.nm.title": "Nouvelle boîte mail",
  "mod.nm.sub": "Créez une boîte mail pour l’un de vos domaines.",
  "mod.nm.local": "Adresse",
  "mod.nm.domain": "Domaine",
  "mod.nm.pwd": "Mot de passe",
  "mod.nm.pwd.gen": "Générer",
  "mod.nm.quota": "Quota",
  "mod.nm.cta": "Créer la boîte mail",
  "mod.pwd.title": "Modifier le mot de passe",
  "mod.pwd.sub": "Le nouveau mot de passe est actif immédiatement. Les clients connectés devront se reconnecter.",
  "mod.pwd.new": "Nouveau mot de passe",
  "mod.pwd.confirm": "Confirmer le mot de passe",
  "mod.pwd.show": "Afficher",
  "mod.pwd.hide": "Masquer",
  "mod.pwd.cta": "Enregistrer le mot de passe",
  "mod.pwd.mismatch": "Les mots de passe ne correspondent pas.",
  "mod.pwd.weak": "Le mot de passe est trop faible. Utilisez au moins 10 caractères.",
  "mod.alias.title": "Ajouter un alias",
  "mod.alias.sub": "Créez une nouvelle adresse qui arrive dans cette boîte mail.",
  "mod.alias.local": "Alias",
  "mod.alias.domain": "Domaine",
  "mod.alias.cta": "Créer l’alias",
  "mod.efilter.title.edit": "Modifier le filtre",
  "mod.efilter.title.new": "Nouveau filtre",
  "mod.efilter.name": "Nom",
  "mod.efilter.if": "Si",
  "mod.efilter.value": "Valeur",
  "mod.efilter.then": "Action",
  "mod.efilter.cta": "Enregistrer le filtre",
  "mod.delmb.title": "Supprimer la boîte mail\u00a0?",
  "mod.delmb.body": "Tous les messages seront perdus. Cette action est irréversible.",
  "mod.delmb.confirm": "Saisissez l’adresse pour confirmer",
  "mod.delmb.cta": "Supprimer la boîte mail",
  "eact.webmail": "Ouvrir le webmail",
  "eact.pwd": "Modifier le mot de passe",
  "eact.forward": "Configurer le transfert",
  "eact.vacation": "Activer la réponse automatique",
  "eact.alias": "Ajouter un alias",
  "eact.pause": "Mettre la boîte mail en pause",
  "eact.resume": "Réactiver la boîte mail",
  "eact.delete": "Supprimer",
  "tst.mb_created": "Boîte mail créée",
  "tst.mb_deleted": "Boîte mail supprimée",
  "tst.pwd_changed": "Mot de passe modifié",
  "tst.alias_added": "Alias ajouté",
  "tst.alias_removed": "Alias supprimé",
  "tst.filter_saved": "Filtre enregistré",
  "tst.filter_deleted": "Filtre supprimé",
  "tst.vacation_on": "Réponse automatique activée",
  "tst.vacation_off": "Réponse automatique désactivée",
  "tst.forward_on": "Transfert activé",
  "tst.forward_off": "Transfert désactivé",
  "tst.mb_paused": "Boîte mail mise en pause",
  "tst.mb_resumed": "Boîte mail réactivée",
  "tst.webmail": "Ouverture du webmail dans un nouvel onglet…",
  "mod.edit_alias.title.alias": "Modifier l’alias",
  "mod.edit_alias.title.forward": "Modifier le transfert",
  "mod.edit_alias.title.catchall": "Modifier le catch-all",
  "mod.edit_alias.from": "Adresse",
  "mod.edit_alias.to": "Arrive dans",
  "mod.edit_alias.to.external": "Transférer vers",
  "tst.edited": "Mis à jour",
  "spam.title": "Paramètres anti-spam",
  "spam.sub": "Quel niveau de filtrage anti-spam souhaitez-vous pour tous vos domaines\u00a0?",
  "spam.level": "Niveau de filtrage",
  "spam.lvl.strict": "Strict",
  "spam.lvl.strict.d": "Tout ce qui est un tant soit peu suspect est bloqué. Quelques faux positifs.",
  "spam.lvl.balanced": "Équilibré",
  "spam.lvl.balanced.d": "Recommandé. Le spam va dans le dossier spam, les e-mails douteux sont distribués avec une étiquette.",
  "spam.lvl.lenient": "Souple",
  "spam.lvl.lenient.d": "Ne bloquer que le spam évident. Plus d’e-mails dans votre boîte de réception, spam compris.",
  "spam.greylist": "Greylisting",
  "spam.greylist.d": "Refuser une première fois les expéditeurs inconnus. Efficace contre les bots\u00a0; la distribution est légèrement retardée.",
  "spam.blocklist": "Liste de blocage",
  "spam.blocklist.add": "Ajouter une adresse ou un domaine",
  "spam.allowlist": "Liste d’autorisation",
  "spam.allowlist.add": "Ajouter une adresse ou un domaine",
  "spam.scope": "S’applique à",
  "spam.scope.all": "Tous les domaines",
  "spam.scope.pick": "Par domaine",
  "tst.spam_saved": "Paramètres anti-spam enregistrés",
  "mod.devlogout.title": "Déconnecter l’appareil\u00a0?",
  "mod.devlogout.body": "L’appareil devra se reconnecter pour accéder de nouveau à cette boîte mail.",
  "mod.devlogout.cta": "Oui, déconnecter",
  "tst.dev_logged_out": "Appareil déconnecté",
  "bk.title": "Sauvegardes",
  "bk.sub": "Sauvegardes quotidiennes automatiques de tous vos sites et boîtes mail. Revenez rapidement à n’importe quel moment antérieur.",
  "bk.new": "Sauvegarder maintenant",
  "bk.schedule": "Modifier la planification",
  "bk.kpi.last": "Dernière sauvegarde",
  "bk.kpi.success": "Réussies (30 j)",
  "bk.kpi.storage": "Stockage des sauvegardes",
  "bk.kpi.retention": "Conservation",
  "bk.banner.title": "Tout fonctionne. Sauvegardes terminées hier à 04:12.",
  "bk.banner.body": "3 sites et 9 boîtes mail sauvegardés avec succès. Aucune action requise.",
  "bk.banner.cta": "Journal d’activité",
  "bk.list.title": "Par site",
  "bk.col.site": "Site",
  "bk.col.last": "Dernière sauvegarde",
  "bk.col.snapshots": "Instantanés",
  "bk.col.size": "Taille",
  "bk.col.next": "Prochaine sauvegarde",
  "bk.col.status": "Statut",
  "bk.status.healthy": "OK",
  "bk.status.warn": "À vérifier",
  "bk.status.running": "En cours",
  "bk.snapshots.title": "Instantanés",
  "bk.snapshots.sub": "Chaque instantané contient les fichiers, bases de données et boîtes mail à ce moment-là.",
  "bk.snap.col.when": "Date",
  "bk.snap.col.kind": "Type",
  "bk.snap.col.size": "Taille",
  "bk.snap.col.includes": "Contenu",
  "bk.snap.col.retention": "Conservé jusqu’au",
  "bk.snap.kind.daily": "Quotidien",
  "bk.snap.kind.weekly": "Hebdomadaire",
  "bk.snap.kind.monthly": "Mensuel",
  "bk.snap.kind.manual": "Manuel",
  "bk.snap.kind.predeploy": "Avant déploiement",
  "bk.tab.snapshots": "Instantanés",
  "bk.tab.settings": "Paramètres",
  "bk.tab.activity": "Activité",
  "bk.act.restore": "Restaurer",
  "bk.act.download": "Télécharger (.zip)",
  "bk.act.contents": "Voir le contenu",
  "bk.act.lock": "Conserver plus longtemps",
  "bk.act.unlock": "Ne plus conserver",
  "bk.act.delete": "Supprimer l’instantané",
  "bk.set.freq.title": "Fréquence",
  "bk.set.freq.sub": "Fréquence des sauvegardes automatiques.",
  "bk.set.freq.hourly": "Toutes les heures",
  "bk.set.freq.daily": "Quotidienne",
  "bk.set.freq.twice": "2 fois par jour",
  "bk.set.ret.title": "Conservation",
  "bk.set.ret.sub": "Durée de conservation de chaque type d’instantané.",
  "bk.set.ret.daily": "Quotidiens",
  "bk.set.ret.weekly": "Hebdomadaires",
  "bk.set.ret.monthly": "Mensuels",
  "bk.set.scope.title": "Contenu d’une sauvegarde",
  "bk.set.scope.sub": "Désactivez les éléments que vous ne souhaitez pas sauvegarder.",
  "bk.set.scope.files": "Fichiers",
  "bk.set.scope.db": "Bases de données",
  "bk.set.scope.mail": "Boîtes mail",
  "bk.set.offsite.title": "Réplication hors site",
  "bk.set.offsite.sub": "Deuxième copie dans un autre datacenter (Eemshaven → Groningue).",
  "bk.includes.files": "Fichiers",
  "bk.includes.db": "Bases de données",
  "bk.includes.mail": "Boîtes mail",
  "bk.activity.title": "Activité",
  "bk.activity.empty": "Aucune activité cette semaine pour l’instant.",
  "mod.restore.title": "Restaurer l’instantané",
  "mod.restore.sub": "Choisissez ce que vous souhaitez restaurer et où. Nous créons d’abord un instantané de sécurité.",
  "mod.restore.what": "Que restaurer",
  "mod.restore.what.all": "Tout",
  "mod.restore.what.files": "Fichiers uniquement",
  "mod.restore.what.db": "Bases de données uniquement",
  "mod.restore.what.mail": "Boîtes mail uniquement",
  "mod.restore.where": "Où",
  "mod.restore.where.live": "Vers le site en production",
  "mod.restore.where.staging": "Vers l’environnement de test",
  "mod.restore.dry": "Simulation\u00a0: afficher les changements sans les appliquer",
  "mod.restore.cta": "Lancer la restauration",
  "mod.restore.warn": "La restauration écrase les fichiers et bases de données actuels. Créez d’abord une sauvegarde manuelle si vous voulez être prudent.",
  "mod.restore.files.title": "Fichiers",
  "mod.restore.files.all": "Tous les fichiers",
  "mod.restore.files.pick": "Choisir des dossiers",
  "mod.restore.files.hint": "Cochez des dossiers/fichiers pour ne restaurer que ceux-ci.",
  "mod.restore.db.title": "Bases de données",
  "mod.restore.db.all": "Toutes les bases de données",
  "mod.restore.db.pick": "Choisir des bases de données",
  "mod.restore.mail.title": "Boîtes mail",
  "mod.restore.mail.all": "Toutes les boîtes mail",
  "mod.restore.mail.pick": "Choisir des boîtes mail",
  "mod.restore.where.sub": "Vers un sous-domaine",
  "mod.restore.sub.label": "Sous-domaine",
  "mod.restore.sub.help": "Nous restaurons l’instantané sur une copie temporaire. Votre site en production reste inchangé.",
  "mod.restore.sub.preview": "Accessible à l’adresse",
  "mod.restore.summary": "Sera restauré",
  "mod.restore.summary.empty": "Sélectionnez au moins un élément ci-dessus.",
  "mod.bnow.title": "Créer une sauvegarde maintenant",
  "mod.bnow.sub": "Créez un instantané manuel. Pratique avant une mise à jour importante.",
  "mod.bnow.scope": "Contenu à inclure",
  "mod.bnow.label": "Libellé (facultatif)",
  "mod.bnow.label.ph": "p. ex. Avant la mise à niveau vers PHP 8.3",
  "mod.bnow.lock": "Ne pas supprimer automatiquement",
  "mod.bnow.cta": "Lancer la sauvegarde",
  "mod.snap.title": "Contenu de l’instantané",
  "mod.snap.files": "Fichiers",
  "mod.snap.db": "Bases de données",
  "mod.snap.mail": "Boîtes mail",
  "mod.snap.size": "Taille",
  "mod.snap.count": "Nombre",
  "mod.snap.kind": "Type",
  "mod.snap.created": "Créé",
  "mod.delsnap.title": "Supprimer l’instantané\u00a0?",
  "mod.delsnap.body": "L’instantané sera supprimé immédiatement. Les autres instantanés restent disponibles.",
  "tst.backup_started": "Sauvegarde lancée",
  "tst.backup_done": "Sauvegarde terminée",
  "tst.restore_started": "Restauration lancée",
  "tst.snapshot_locked": "Instantané épinglé",
  "tst.snapshot_unlocked": "Instantané désépinglé",
  "tst.snapshot_deleted": "Instantané supprimé",
  "tst.schedule_saved": "Planification enregistrée",
  "bl.title": "Facturation",
  "bl.sub": "Factures, moyens de paiement et abonnements au même endroit.",
  "bl.pay": "Payer le solde",
  "bl.pay_method": "Changer de moyen de paiement",
  "bl.address": "Adresse de facturation",
  "bl.kpi.open": "En attente",
  "bl.kpi.this_month": "Ce mois-ci",
  "bl.kpi.next": "Prochaine facture",
  "bl.kpi.method": "Moyen de paiement",
  "bl.banner.title": "Économisez 5 % avec le prélèvement SEPA",
  "bl.banner.body": "Nous prélevons automatiquement à la date d’échéance. Changez en un clic.",
  "bl.banner.cta": "Activer le prélèvement",
  "bl.invoices.title": "Factures récentes",
  "bl.invoices.viewall": "Tout afficher",
  "bl.col.number": "N° de facture",
  "bl.col.date": "Date",
  "bl.col.amount": "Montant",
  "bl.col.due": "Date d’échéance",
  "bl.col.status": "Statut",
  "bl.status.paid": "Payée",
  "bl.status.open": "En attente",
  "bl.status.overdue": "En retard",
  "bl.status.draft": "Brouillon",
  "bl.subs.title": "Abonnements",
  "bl.subs.cancel": "Résilier",
  "bl.subs.viewall": "Gérer les abonnements",
  "bl.methods.title": "Moyens de paiement",
  "bl.methods.add": "Ajouter un moyen",
  "bl.methods.primary": "Principal",
  "bl.methods.set_primary": "Définir comme principal",
  "bl.methods.remove": "Supprimer",
  "bl.address.title": "Adresse de facturation",
  "bl.address.edit": "Modifier",
  "bd.back": "Toutes les factures",
  "bd.invoice": "Facture",
  "bd.items.title": "Détail",
  "bd.items.col.desc": "Description",
  "bd.items.col.period": "Période",
  "bd.items.col.qty": "Qté",
  "bd.items.col.price": "Prix unitaire",
  "bd.items.col.amount": "Montant",
  "bd.items.subtotal": "Sous-total",
  "bd.items.vat": "TVA (21 %)",
  "bd.items.total": "Total",
  "bd.actions.download": "Télécharger le PDF",
  "bd.actions.send": "Envoyer une copie",
  "bd.actions.print": "Imprimer",
  "bd.actions.pay": "Payer maintenant",
  "bd.history.title": "Historique",
  "bd.notes.title": "Notes",
  "bd.notes.empty": "Aucune note sur cette facture.",
  "mod.pay.title": "Payer la facture",
  "mod.pay.sub": "Choisissez un moyen de paiement. Le montant est réglé immédiatement.",
  "mod.pay.amount": "Montant",
  "mod.pay.method": "Moyen",
  "mod.pay.cta": "Payer maintenant",
  "mod.pm.title": "Ajouter un moyen de paiement",
  "mod.pm.sub": "Choisissez un moyen de paiement. Nous l’enregistrons en toute sécurité pour les paiements récurrents.",
  "mod.pm.kind": "Type",
  "mod.pm.kind.ideal": "iDEAL",
  "mod.pm.kind.card": "Carte de crédit",
  "mod.pm.kind.sepa": "Prélèvement SEPA",
  "mod.pm.bank": "Banque",
  "mod.pm.iban": "IBAN",
  "mod.pm.holder": "Titulaire du compte",
  "mod.pm.card.num": "Numéro de carte",
  "mod.pm.card.exp": "Date d’expiration",
  "mod.pm.card.cvc": "CVC",
  "mod.pm.cta": "Ajouter le moyen",
  "mod.pm.set_primary": "Définir comme moyen principal",
  "mod.addr.title": "Modifier l’adresse de facturation",
  "mod.addr.company": "Société",
  "mod.addr.attn": "À l’attention de",
  "mod.addr.street": "Adresse",
  "mod.addr.zip": "Code postal",
  "mod.addr.city": "Ville",
  "mod.addr.country": "Pays",
  "mod.addr.vat": "N° de TVA",
  "mod.addr.email": "E-mail de facturation",
  "mod.addr.cta": "Enregistrer",
  "mod.canceluse.title": "Résilier l’abonnement\u00a0?",
  "mod.canceluse.body": "L’abonnement reste actif jusqu’à la fin de la période en cours. La formule est ensuite désactivée.",
  "mod.canceluse.cta": "Oui, résilier",
  "tst.invoice_paid": "Facture payée",
  "tst.payment_started": "Paiement lancé",
  "tst.method_added": "Moyen ajouté",
  "tst.method_removed": "Moyen supprimé",
  "tst.method_primary": "Moyen principal défini",
  "tst.address_saved": "Adresse enregistrée",
  "tst.subscription_canceled": "Abonnement résilié",
  "tst.invoice_sent": "Facture envoyée",
  "tst.print": "Ouverture de la fenêtre d’impression…",
  "dd.nameservers": "Serveurs de noms",
  "dd.lock": "Verrou de transfert",
  "dd.linked.title": "Services associés",
  "dns.simple": "Mode simple",
  "dns.advanced": "Avancé",
  "dns.tasks.title": "Que souhaitez-vous faire\u00a0?",
  "dns.tasks.sub": "Choisissez une tâche courante et nous configurons les enregistrements DNS pour vous.",
  "dns.task.website": "Pointer vers mon site web",
  "dns.task.website.d": "Définissez des enregistrements A et CNAME pour que les visiteurs atteignent votre site.",
  "dns.task.mail": "Mes e-mails passent par…",
  "dns.task.mail.d": "Configurez les enregistrements MX pour Google Workspace, Microsoft 365 ou DMRS Mail.",
  "dns.task.verify": "Vérifier un service",
  "dns.task.verify.d": "Ajoutez un enregistrement TXT pour prouver la propriété (Google, Meta, …).",
  "dns.task.forward": "Rediriger vers une autre URL",
  "dns.task.forward.d": "Redirigez les visiteurs de ce domaine vers p. ex. example.com.",
  "dns.records.title": "Tous les enregistrements DNS",
  "dns.records.add": "Ajouter un enregistrement",
  "dns.records.help": "Pas sûr\u00a0? Utilisez le mode simple ci-dessus.",
  "dns.col.type": "Type",
  "dns.col.name": "Nom",
  "dns.col.value": "Valeur",
  "dns.col.ttl": "TTL",
  "tw.title": "Pointer {domain} vers votre site web",
  "tw.sub": "Choisissez où votre site est hébergé. Nous définissons les bons enregistrements DNS.",
  "tw.opt.dmrs": "Hébergement DMRS (ce client)",
  "tw.opt.ip": "Une autre adresse IP",
  "tw.opt.host": "Un autre nom d’hôte (p. ex. monsite.netlify.app)",
  "tw.cancel": "Annuler",
  "tw.apply": "Appliquer",
  "tw.preview": "Nous allons créer ces enregistrements\u00a0:",
  "mr.title": "Routage des e-mails",
  "mr.sub": "Choisissez le serveur qui reçoit les e-mails de ce domaine.",
  "mr.current": "Configuration actuelle",
  "mr.change": "Changer de fournisseur",
  "mr.preset.dmrs": "DMRS Mail",
  "mr.preset.dmrs.d": "Inclus dans votre formule d’hébergement. 6 boîtes mail actives.",
  "mr.preset.google": "Google Workspace",
  "mr.preset.google.d": "Gmail pour votre domaine. Nécessite un compte Workspace.",
  "mr.preset.ms": "Microsoft 365",
  "mr.preset.ms.d": "Outlook pour votre domaine. Nécessite un compte M365.",
  "mr.preset.none": "Pas d’e-mail",
  "mr.preset.none.d": "Ne recevez aucun e-mail sur ce domaine. Supprime les enregistrements MX.",
  "mr.preset.custom": "Autre fournisseur",
  "mr.preset.custom.d": "Saisissez vos propres enregistrements MX (p. ex. Fastmail, ProtonMail).",
  "mr.deliverability": "Délivrabilité",
  "mr.spf": "SPF",
  "mr.dkim": "DKIM",
  "mr.dmarc": "DMARC",
  "mr.healthy": "Bien configuré",
  "fw.title": "Redirection",
  "fw.sub": "Redirigez automatiquement les visiteurs vers une autre URL.",
  "fw.add": "Ajouter une redirection",
  "fw.col.from": "De",
  "fw.col.to": "Vers",
  "fw.col.type": "Type",
  "fw.col.code": "Code de statut",
  "fw.type.permanent": "Permanente",
  "fw.type.temporary": "Temporaire",
  "fw.empty.title": "Aucune redirection pour l’instant",
  "fw.empty.sub": "Redirigez par exemple tout le domaine vers une autre adresse, ou /blog vers votre Medium.",
  "ds.title": "Paramètres",
  "ds.sub": "Coordonnées, serveurs de noms et transfert de domaine.",
  "ds.contact.title": "Coordonnées",
  "ds.contact.sub": "Utilisées pour le WHOIS et les communications officielles du registre.",
  "ds.contact.edit": "Modifier les contacts",
  "ds.ns.title": "Serveurs de noms",
  "ds.ns.sub": "Par défaut, ils pointent vers les serveurs de noms DMRS. Ne les modifiez que si vous savez ce que vous faites.",
  "ds.ns.use_dmrs": "Utiliser les serveurs de noms DMRS",
  "ds.ns.custom": "Serveurs de noms personnalisés",
  "ds.danger.title": "Transférer le domaine",
  "ds.danger.sub": "Demandez un code de transfert pour transférer ce domaine vers un autre registraire.",
  "ds.danger.get": "Demander le code de transfert",
  "ds.dnssec.title": "DNSSEC",
  "ds.dnssec.sub": "Protège les réponses DNS contre la falsification. Recommandé.",
  "ds.dnssec.active": "DNSSEC actif",
  "ds.dnssec.algo": "Algorithme",
  "ds.dnssec.keytag": "Key tag",
  "ds.dnssec.ds": "Enregistrement DS",
  "ds.dnssec.keys.title": "Enregistrements DS personnalisés",
  "ds.dnssec.keys.sub": "Ajoutez les enregistrements DS de votre fournisseur DNS externe.",
  "ds.dnssec.keys.add": "Ajouter un enregistrement DS",
  "ds.dnssec.keys.empty": "Aucun enregistrement DS personnalisé. DMRS gère les clés.",
  "mod.dnssec.title": "Ajouter un enregistrement DS",
  "mod.dnssec.keytag": "Key tag",
  "mod.dnssec.algo": "Algorithme",
  "mod.dnssec.digestType": "Type de digest",
  "mod.dnssec.digest": "Digest",
  "mod.dnssec.cta": "Ajouter l’enregistrement DS",
  "tst.ds_added": "Enregistrement DS ajouté",
  "tst.ds_removed": "Enregistrement DS supprimé",
  "mod.contacts.title": "Modifier les contacts",
  "mod.contacts.sub": "Le titulaire et le contact technique sont utilisés pour le WHOIS et les communications officielles du registre.",
  "mod.contacts.role.holder": "Titulaire",
  "mod.contacts.role.tech": "Contact technique",
  "mod.contacts.role.admin": "Contact administratif",
  "mod.contacts.role.billing": "Contact de facturation",
  "mod.contacts.name": "Nom",
  "mod.contacts.email": "E-mail",
  "mod.contacts.phone": "Téléphone",
  "mod.contacts.handle": "Handle",
  "mod.contacts.handle.ph": "p. ex. JANS001",
  "mod.contacts.handle.search": "Rechercher le handle",
  "mod.contacts.handle.searching": "Recherche…",
  "mod.contacts.handle.notfound": "Aucun handle trouvé — saisissez-le manuellement.",
  "mod.contacts.handle.help": "Handle de ce contact auprès du registre. Récupéré automatiquement plus tard.",
  "tst.contacts_saved": "Contacts enregistrés",
  "mod.transfer.method": "Recevoir le code par",
  "mod.transfer.method.email": "E-mail sécurisé",
  "mod.transfer.method.sms": "SMS au numéro enregistré",
  "mod.transfer.method.email.d": "Nous envoyons le code à l’adresse du titulaire. Plus sûr\u00a0: il n’apparaît pas dans le panneau.",
  "mod.transfer.dnssec.title": "Désactivez d’abord DNSSEC",
  "mod.transfer.dnssec.body": "De nombreux transferts échouent parce que DNSSEC est encore actif chez l’ancien registraire. Désactivez-le ici pour que le nouveau registraire puisse le reconfigurer.",
  "mod.transfer.dnssec.cta": "Désactiver DNSSEC",
  "mod.transfer.dnssec.skip": "Laisser DNSSEC activé",
  "mod.transfer.send": "Envoyer le code de transfert",
  "tst.transfer_sent": "Code de transfert envoyé à votre adresse e-mail",
  "ds.ns.save": "Enregistrer les serveurs de noms",
  "ds.ns.invalid": "Saisissez au moins 2 serveurs de noms valides.",
  "mod.ns.title": "Modifier les serveurs de noms\u00a0?",
  "mod.ns.body": "Une modification peut prendre jusqu’à 24 h pour être effective partout. Pendant ce temps, votre site ou vos e-mails peuvent être brièvement inaccessibles.",
  "mod.ns.cta": "Oui, modifier les serveurs de noms",
  "tst.ns_saved": "Serveurs de noms enregistrés",
  "tst.dnssec_on": "DNSSEC activé",
  "tst.dnssec_off": "DNSSEC désactivé",
  "mod.transfer.title": "Demander le code de transfert",
  "mod.transfer.sub": "Transmettez ce code à votre nouveau registraire pour y transférer ce domaine.",
  "mod.transfer.code": "Code de transfert",
  "mod.transfer.warn": "Une fois le transfert lancé, vous ne pourrez plus rien modifier ici. Annulez d’abord les modifications en cours.",
  "mod.transfer.copy": "Copier le code",
  "mod.transfer.email": "Envoyer à mon e-mail",
  "tst.transfer_code": "Code de transfert régénéré",
  "mm.title": "Mes e-mails passent par…",
  "mm.sub": "Choisissez votre fournisseur d’e-mail. Nous préparons les bons enregistrements MX pour vous.",
  "mm.confirm": "Remplacer les enregistrements MX maintenant",
  "vm.title": "Vérifier un service",
  "vm.sub": "De nombreux services vous demandent d’ajouter un enregistrement TXT pour prouver que ce domaine vous appartient.",
  "vm.svc": "Quel service\u00a0?",
  "vm.token": "Code de vérification",
  "vm.token.placeholder": "Collez ici le code de Google Search Console ou d’un autre service",
  "vm.create": "Créer l’enregistrement TXT",
  "fwm.title": "Rediriger vers une autre URL",
  "fwm.from": "De (ce domaine)",
  "fwm.to": "Vers (URL complète)",
  "fwm.kind.full": "Domaine entier",
  "fwm.kind.path": "Chemin spécifique",
  "fwm.kind.title": "Que souhaitez-vous rediriger\u00a0?",
  "fwm.code": "Code de statut",
  "fwm.code.301": "301 — Permanente (recommandé)",
  "fwm.code.302": "302 — Temporaire",
  "fwm.create": "Créer la redirection",
  "rec.add.title": "Ajouter un enregistrement DNS",
  "rec.edit.title": "Modifier l’enregistrement DNS",
  "rec.type": "Type",
  "rec.name": "Nom",
  "rec.name.help": "Utilisez @ pour le domaine principal. P. ex. www, mail ou api.",
  "rec.value": "Valeur",
  "rec.value.help.A": "Une adresse IPv4, p. ex. 185.182.56.42",
  "rec.value.help.AAAA": "Une adresse IPv6, p. ex. 2a01:7c8::1",
  "rec.value.help.CNAME": "Un nom d’hôte vers lequel cet enregistrement doit pointer.",
  "rec.value.help.MX": "Priorité (plus bas = plus important) suivie du serveur mail, p. ex. 10 mail.dmrs.nl",
  "rec.value.help.TXT": "Texte libre, souvent utilisé pour la vérification et l’e-mail (SPF, DKIM, DMARC).",
  "rec.value.help.SRV": "Priorité, poids, port et cible — p. ex. 10 100 443 sip.example.com",
  "rec.ttl": "TTL (secondes)",
  "rec.ttl.help": "Durée pendant laquelle d’autres serveurs peuvent mettre cet enregistrement en cache. 3600 (1 heure) est la valeur standard.",
  "rec.prio": "Priorité",
  "rec.save": "Enregistrer",
  "rec.delete": "Supprimer l’enregistrement",
  "rec.delete.confirm": "Voulez-vous vraiment supprimer cet enregistrement\u00a0?",
  "common.loading": "Chargement…",
  "format.justNow": "à l’instant",
  "format.perMonth": "{amount}/mois",
  "invoiceStatus.paid": "Payée",
  "invoiceStatus.open": "En attente",
  "invoiceStatus.overdue": "En retard",
  "invoiceStatus.failed": "Paiement échoué",
  "invoiceStatus.cancelled": "Annulée",
  "hostingStatus.active": "Actif",
  "hostingStatus.suspended": "Suspendu",
  "hostingStatus.terminated": "Résilié",
  "hostingStatus.pending": "En cours de configuration",
  "hostingStatus.pending_cancellation": "Résiliation en cours",
  "health.healthy": "En ligne",
  "health.degraded": "Perturbé",
  "health.down": "Hors ligne",
  "health.unknown": "Actif",
  "health.checked": "Vérifié {time}",
  "notif.invoice.overdue": "La facture {number} est en retard",
  "notif.invoice.failed": "Le paiement de {number} a échoué",
  "notif.invoice.open": "La facture {number} est en attente de paiement",
  "notif.invoice.body": "{amount} · échéance le {date}",
  "notif.hosting.suspended": "{domain} est suspendu",
  "notif.hosting.suspended.body": "Contactez-nous ou réglez les factures en attente.",
  "notif.hosting.pending": "{domain} est en cours de configuration",
  "notif.hosting.pending.body": "Nous vous préviendrons dès que l’hébergement sera prêt.",
  "notif.hosting.down": "{domain} est inaccessible",
  "notif.hosting.down.body": "Nous nous en occupons. Consultez l’hébergement pour plus de détails.",
  "domainError.empty": "Saisissez un nom de domaine.",
  "domainError.url": "Saisissez uniquement le nom de domaine, sans http:// ni chemin (p. ex. exemple.fr).",
  "domainError.email": "Cela ressemble à une adresse e-mail. Saisissez uniquement le nom de domaine.",
  "domainError.space": "Un nom de domaine ne peut pas contenir d’espaces.",
  "domainError.www": "Omettez «\u00a0www.\u00a0»\u00a0: nous le configurons automatiquement.",
  "domainError.no_tld": "Ajoutez l’extension, par exemple .fr ou .com.",
  "domainError.too_long": "Ce nom de domaine est trop long (253 caractères maximum).",
  "domainError.empty_label": "Il y a deux points consécutifs ou un point au début.",
  "domainError.label_too_long": "Chaque partie entre les points peut compter au maximum 63 caractères.",
  "domainError.tld": "Cette extension n’est pas valide.",
  "domainError.chars": "Utilisez uniquement des lettres, des chiffres et des traits d’union.",
  "domainError.hyphen": "Un nom de domaine ne peut ni commencer ni se terminer par un trait d’union.",
  "lang.label": "Langue",
  "domainsPage.loadError": "Impossible de charger les domaines",
  "domainsPage.notFound": "Domaine introuvable",
  "domainsPage.search": "Rechercher un domaine…",
  "domainsPage.filter.pending": "En cours",
  "domainsPage.dnsPick.title": "Ajouter un enregistrement DNS",
  "domainsPage.dnsPick.none": "Vous n’avez encore aucun domaine. Ajoutez d’abord un domaine.",
  "domainsPage.dnsPick.choose": "Choisissez ci-dessous le domaine auquel vous souhaitez ajouter un enregistrement.",
  "domainsPage.dismiss": "Fermer",
  "domainsPage.empty": "Aucun domaine trouvé.",
  "domainsPage.notLinked": "Non associé",
  "domainsPage.autoRenew.on": "Renouvellement automatique activé",
  "domainsPage.autoRenew.off": "Renouvellement automatique désactivé",
  "domainsPage.status.active": "Actif",
  "domainsPage.status.pending": "En cours",
  "domainsPage.status.transferring": "En transfert",
  "domainsPage.status.expired": "Expiré",
  "domainsPage.status.suspended": "Suspendu",
  "domainsPage.status.cancelled": "Annulé",
  "domainsPage.status.unknown": "Inconnu",
  "domainsPage.days.expired": "expiré",
  "domainsPage.days.today": "aujourd’hui",
  "domainsPage.days.one": "dans 1 jour",
  "domainsPage.days.other": "dans {n} jours",
  "addDomain.duplicate": "Ce domaine figure déjà dans votre compte.",
  "addDomain.requested": "{domain} a été demandé",
  "addDomain.exists": "Ce domaine est déjà enregistré dans notre système.",
  "addDomain.confirm.title": "Confirmer l’enregistrement",
  "addDomain.confirm.description": "Vérifiez les informations. Une fois confirmé, l’enregistrement est demandé.",
  "addDomain.back": "Retour",
  "addDomain.working": "En cours…",
  "addDomain.register": "Enregistrer le domaine",
  "addDomain.term": "Durée",
  "addDomain.cost": "Coût",
  "addDomain.cost.value": "Au tarif en vigueur pour {tld}\u00a0; le montant figurera sur votre prochaine facture.",
  "addDomain.next": "Suivant",
  "addDomain.name": "Nom de domaine",
  "addDomain.name.hint": "Le nom de domaine complet, extension comprise (.fr, .com, .eu, …).",
  "addDomain.name.placeholder": "exemple.fr",
  "emailList.domains.one": "{n} domaine",
  "emailList.domains.other": "{n} domaines",
  "emailList.kpi.allocated": "alloué au total",
  "emailList.kpi.noMetric": "Aucune mesure",
  "emailList.search": "Rechercher une boîte mail…",
  "emailList.group.byDomain": "Par domaine",
  "emailList.group.flat": "Tout",
  "emailList.loadError": "Impossible de charger les boîtes mail",
  "emailList.empty.title": "Aucune boîte mail pour l’instant",
  "emailList.empty.body": "Créez votre première boîte mail.",
  "emailList.noResults.title": "Aucune boîte mail trouvée",
  "emailList.noResults.body": "Modifiez votre recherche ou votre filtre.",
  "emailList.addresses.one": "{n} adresse",
  "emailList.addresses.other": "{n} adresses",
  "emailList.status.suspended": "Suspendue",
  "emailList.status.pending": "En attente",
  "emailList.status.disabled": "Désactivée",
  "emailList.new.localError": "Avant le @, utilisez uniquement des lettres, des chiffres et . _ - + (ni au début ni à la fin).",
  "mailDomain.add": "Ajouter un domaine e-mail",
  "mailDomain.description": "Choisissez un domaine ou une formule d’hébergement de votre compte. Nous configurons le serveur de messagerie et les enregistrements DNS (MX, SPF, DKIM, DMARC) pour vous.",
  "mailDomain.activate": "Activer l’e-mail",
  "mailDomain.stop": "Désactiver l'e-mail",
  "mailDomain.stopHint": "Désactivez l'e-mail chez nous pour passer à un autre fournisseur de messagerie.",
  "mailDomain.stopTitle": "Désactiver l'e-mail pour {domain} ?",
  "mailDomain.stopBody": "Les {n} boîtes mail, les alias et leurs messages sont supprimés définitivement, et les enregistrements mail (MX, SPF, DKIM) sont retirés du DNS. Cette action est irréversible.",
  "mailDomain.stopped": "L'e-mail pour {domain} a été désactivé.",
  "mailDomain.activated": "E-mail activé pour {domain}",
  "mailDomain.none": "Tous vos domaines ont déjà l’e-mail. Ajoutez d’abord un domaine ou une formule d’hébergement.",
  "mailDomain.firstActivate": "Vous n’avez pas encore de domaine e-mail.",
  "mailDomain.routingHint": "Vous voulez des boîtes mail sur ce domaine chez nous\u00a0? Activez l’e-mail et nous configurons le serveur et les enregistrements DNS.",
  "mailDomain.err.notOwned": "Ce domaine ne figure pas sur votre compte. Ajoutez d’abord le domaine ou une formule d’hébergement.",
  "mailDomain.err.exists": "L’e-mail est déjà actif pour ce domaine.",
  "emailList.new.chooseDomain": "— Choisir un domaine —",
  "emailList.new.username": "Nom d’utilisateur (avant le @)",
  "emailList.new.quota": "Quota (Mo)",
  "emailDetail.working": "En cours…",
  "emailDetail.create": "Créer",
  "emailDetail.delete": "Supprimer",
  "emailDetail.change": "Modifier",
  "emailDetail.off": "Désactivé",
  "emailDetail.notFound": "Boîte mail introuvable",
  "emailDetail.quota": "Espace de stockage",
  "emailDetail.forward.keepCopy": "{address} (copie conservée)",
  "emailDetail.client.title": "Paramètres de votre logiciel de messagerie",
  "emailDetail.client.unavailable": "Les informations du serveur ne sont pas encore disponibles pour ce domaine.",
  "emailDetail.pw.min": "12 caractères minimum.",
  "emailDetail.pw.mismatch": "Les mots de passe ne correspondent pas.",
  "emailDetail.forward.saved": "Transfert enregistré",
  "emailDetail.forward.desc": "Transférez le courrier entrant vers une autre adresse.",
  "emailDetail.forward.on": "Transfert activé",
  "emailDetail.forward.to": "Transférer vers",
  "emailDetail.invalidEmail": "Adresse e-mail non valide.",
  "emailDetail.forward.placeholder": "nom@exemple.fr",
  "emailDetail.forward.keep": "Conserver une copie dans cette boîte mail",
  "emailDetail.vacation.defaultSubject": "Absence du bureau",
  "emailDetail.vacation.saved": "Réponse automatique enregistrée",
  "emailDetail.vacation.title": "Réponse automatique",
  "emailDetail.vacation.desc": "Envoyez une réponse automatique pendant vos vacances ou une absence.",
  "emailDetail.vacation.on": "Réponse automatique activée",
  "emailDetail.vacation.placeholder": "Par exemple\u00a0: je suis absent jusqu’à lundi inclus et je vous répondrai dès que possible ensuite.",
  "emailDetail.aliases.desc": "Adresses supplémentaires distribuées dans cette boîte mail.",
  "emailDetail.aliases.empty.title": "Aucun alias pour l’instant",
  "emailDetail.aliases.empty.body": "Créez par exemple info@ ou contact@ comme alias de cette boîte mail.",
  "emailDetail.aliases.deleteAria": "Supprimer {address}",
  "emailDetail.aliases.added": "Alias ajouté",
  "emailDetail.aliases.deleted": "Alias supprimé",
  "emailDetail.aliases.confirmTitle": "Supprimer l’alias\u00a0?",
  "emailDetail.aliases.confirmBody": "Les e-mails envoyés à {address} ne seront plus distribués.",
  "emailDetail.aliasModal.deliversTo": "Le courrier entrant arrivera dans {address}",
  "emailDetail.aliasModal.label": "Alias (partie avant le @)",
  "emailDetail.aliasModal.name": "nom",
  "emailDetail.aliasModal.invalid": "Uniquement des lettres, des chiffres et . _ + -",
  "emailDetail.quota.saved": "Espace de stockage modifié",
  "emailDetail.quota.title": "Espace de stockage",
  "emailDetail.quota.desc": "Espace maximal pour cette boîte mail.",
  "emailDetail.danger.title": "Zone de danger",
  "emailDetail.danger.desc": "La suppression d’une boîte mail est définitive. Tous les e-mails et paramètres seront perdus.",
  "emailDetail.danger.confirmBody": "Voulez-vous vraiment supprimer définitivement {address}\u00a0?",
  "emailDetail.deleted": "Boîte mail supprimée",
  "emailDetail.spam.saved": "Filtre anti-spam enregistré",
  "emailDetail.spam.lenient": "Souple",
  "emailDetail.spam.desc": "Quel niveau de sévérité pour le filtre anti-spam\u00a0?",
  "dashboard.greeting.night": "Bonne nuit",
  "dashboard.greeting.night.named": "Bonne nuit, {name}",
  "dashboard.greeting.morning": "Bonjour",
  "dashboard.greeting.morning.named": "Bonjour, {name}",
  "dashboard.greeting.afternoon": "Bonjour",
  "dashboard.greeting.afternoon.named": "Bonjour, {name}",
  "dashboard.greeting.evening": "Bonsoir",
  "dashboard.greeting.evening.named": "Bonsoir, {name}",
  "dashboard.sites.error": "Impossible de charger vos sites web",
  "dashboard.sites.empty": "Pas encore d’hébergement",
  "dashboard.sites.empty.body": "Commandez une formule d’hébergement pour commencer.",
  "dashboard.usage.none": "Pas encore mesuré",
  "dashboard.activity.empty": "Aucune activité pour l’instant.",
  "detailUi.working": "En cours…",
  "detailUi.notFound": "Introuvable",
  "detailUi.loadFailed": "Échec du chargement",
  "detailUi.retry": "Réessayer",
  "newPlan.title": "Nouvelle formule d’hébergement",
  "newPlan.description": "Choisissez une formule et associez un domaine.",
  "newPlan.created": "Hébergement créé",
  "newPlan.create": "Créer",
  "newPlan.packages.error": "Impossible de charger les formules. {error}",
  "newPlan.domain.placeholder": "exemple.fr",
  "newPlan.package": "Formule",
  "newPlan.packages.loading": "Chargement des formules…",
  "newPlan.package.choose": "— Choisissez une formule —",
  "hostingList.onServers.one": "sur {n} serveur",
  "hostingList.onServers.other": "sur {n} serveurs",
  "hostingList.storage.allocated": "total alloué",
  "hostingList.traffic.none": "aucune mesure",
  "hostingList.error": "Impossible de charger l’hébergement",
  "hostingList.empty": "Aucun hébergement",
  "hostingList.empty.body": "Ajoutez votre première formule pour commencer.",
  "hostingList.servers.none": "Aucune information sur le serveur disponible.",
  "hostingList.sites.one": "{n} site",
  "hostingList.sites.other": "{n} sites",
  "hostingList.addPlanFirst": "Ajoutez d’abord une formule",
  "hostingList.serverStatus.online": "En ligne",
  "hostingList.serverStatus.offline": "Hors ligne",
  "hostingList.serverStatus.provisioning": "En cours de configuration",
  "hostingList.serverStatus.error": "Erreur",
  "hostingDetail.notFound": "Hébergement introuvable",
  "hostingDetail.tab.access": "Accès SFTP",
  "hostingDetail.ssl.settingUp": "Le SSL est en cours de configuration",
  "hostingDetail.price": "Prix",
  "hostingDetail.storage": "Stockage",
  "hostingDetail.memory": "Mémoire",
  "hostingDetail.runtime": "Environnement",
  "hostingDetail.addons": "Options",
  "hostingDetail.created": "Créé le",
  "hostingDetail.nextInvoice": "Prochaine facture",
  "hostingDetail.lastChanged": "Dernière modification",
  "hostingDetail.ssl.provider": "Fournisseur",
  "hostingDetail.ssl.status": "Statut",
  "hostingDetail.ssl.active": "Actif",
  "hostingDetail.ssl.inactive": "Inactif",
  "hostingDetail.ssl.enable": "Activer le SSL",
  "hostingDetail.ssl.selfsigned": "Certificat temporaire",
  "hostingDetail.ssl.temporary": "Temporaire — les navigateurs affichent un avertissement",
  "hostingDetail.ssl.selfsignedHint": "Dès que votre domaine pointe vers ce serveur, nous installons automatiquement un certificat Let's Encrypt gratuit.",
  "hostingDetail.copied": "Copié",
  "hostingDetail.copyFailed": "Échec de la copie",
  "hostingDetail.copy": "Copier",
  "hostingDetail.protocol": "Protocole",
  "hostingDetail.sftp.users": "Utilisateurs SFTP",
  "hostingDetail.sftp.addUser": "Ajouter un utilisateur",
  "hostingDetail.sftp.limit": "Votre formule a atteint son maximum de {max} utilisateur(s) SFTP.",
  "hostingDetail.sftp.empty": "Aucun utilisateur SFTP pour l’instant.",
  "hostingDetail.sftp.noServer": "Cet hébergement n’a pas encore de serveur\u00a0; le SFTP sera disponible dès qu’il sera configuré.",
  "hostingDetail.sftp.createdOn": "Créé le {date}",
  "hostingDetail.sftp.newPassword": "Nouveau mot de passe",
  "hostingDetail.delete": "Supprimer",
  "hostingDetail.sftp.deleteUser": "Supprimer {name}",
  "hostingDetail.sftp.reset.title": "Générer un nouveau mot de passe\u00a0?",
  "hostingDetail.sftp.reset.body": "Le mot de passe actuel de {name} ne fonctionnera plus.",
  "hostingDetail.sftp.reset.cta": "Générer",
  "hostingDetail.sftp.delete.title": "Supprimer l’utilisateur SFTP\u00a0?",
  "hostingDetail.sftp.delete.body": "{name} ne pourra plus se connecter.",
  "hostingDetail.sftp.deleted": "Utilisateur supprimé",
  "hostingDetail.sftp.add.title": "Ajouter un utilisateur SFTP",
  "hostingDetail.sftp.add.description": "Le mot de passe s’affiche une seule fois après la création.",
  "hostingDetail.sftp.add.username": "Nom d’utilisateur (facultatif)",
  "hostingDetail.sftp.add.usernameHint": "Lettres minuscules, chiffres, - et _. Laissez vide pour un nom automatique.",
  "hostingDetail.sftp.add.invalid": "Nom d’utilisateur non valide.",
  "hostingDetail.secret.title": "Conservez ce mot de passe",
  "hostingDetail.secret.description": "Il ne s’affiche qu’une seule fois.",
  "hostingDetail.secret.done": "Je l’ai enregistré",
  "hostingDetail.user": "Utilisateur",
  "hostingDetail.db.adminer": "Ouvrir Adminer",
  "hostingDetail.db.none": "Cette formule n’inclut pas de base de données.",
  "hostingDetail.db.type": "Type",
  "hostingDetail.db.database": "Base de données",
  "hostingDetail.db.host": "Hôte (depuis votre site)",
  "hostingDetail.db.password": "Mot de passe",
  "hostingDetail.hide": "Masquer",
  "hostingDetail.show": "Afficher",
  "hostingDetail.runtime.current": "Environnement actuel",
  "hostingDetail.runtime.change": "Besoin d’une autre version\u00a0? Contactez le support, nous la changerons pour vous.",
  "hostingDetail.cancel.pendingUntil": "Résilié. L’hébergement reste actif jusqu’au {date}.",
  "hostingDetail.cancel.pendingEndOfPeriod": "Résilié. L’hébergement reste actif jusqu’à la fin de la période.",
  "hostingDetail.cancel.info": "La résiliation prend effet à la fin de la période en cours. Tous les fichiers sont ensuite supprimés.",
  "hostingDetail.revoke.button": "Annuler la résiliation",
  "hostingDetail.restart.title": "Redémarrer l’hébergement\u00a0?",
  "hostingDetail.restart.started": "Redémarrage lancé",
  "hostingDetail.cancel.title": "Résilier l’hébergement\u00a0?",
  "hostingDetail.cancel.body": "Voulez-vous vraiment résilier {domain}\u00a0?",
  "hostingDetail.cancel.submitted": "Demande de résiliation envoyée",
  "hostingDetail.revoke.title": "Annuler la résiliation\u00a0?",
  "hostingDetail.revoke.body": "L’hébergement continuera normalement.",
  "hostingDetail.revoke.cta": "Annuler la résiliation",
  "hostingDetail.revoke.done": "Résiliation annulée",
  "billingPage.noPaymentLink": "Aucun lien de paiement reçu. Veuillez réessayer plus tard.",
  "billingPage.mandate.loadFailed": "chargement impossible",
  "billingPage.mandate.none": "aucun moyen configuré",
  "billingPage.openCount.one": "{n} facture",
  "billingPage.openCount.other": "{n} factures",
  "billingPage.allPaid": "tout est payé",
  "billingPage.inclVat": "TVA incluse",
  "billingPage.next.approx": "env. {amount}",
  "billingPage.next.none": "aucun abonnement en cours",
  "billingPage.sepa.enabled": "Prélèvement SEPA activé",
  "billingPage.sepa.body": "Les factures sont prélevées automatiquement à la date d’échéance.",
  "billingPage.revoke.cta": "Révoquer le mandat",
  "billingPage.noInvoices": "Aucune facture.",
  "billingPage.renews": "renouvellement le {date}",
  "billingPage.noSubscriptions": "Aucun abonnement.",
  "billingPage.add": "Ajouter",
  "billingPage.method.loadFailed": "Impossible de récupérer votre moyen de paiement.",
  "billingPage.retry": "Réessayer",
  "billingPage.method.none": "Aucun moyen de paiement configuré.",
  "billingPage.mandateStatus.valid": "actif",
  "billingPage.mandateStatus.pending": "en cours de traitement",
  "billingPage.mandateStatus.invalid": "non valide",
  "billingPage.mandateStatus.revoked": "révoqué",
  "billingPage.revoke.done": "Mandat révoqué",
  "billingPage.revoke.title": "Révoquer le mandat de prélèvement SEPA\u00a0?",
  "billingPage.revoke.body": "Les factures ne seront plus prélevées automatiquement. Vous les réglerez vous-même depuis la page de la facture.",
  "billingPage.working": "En cours…",
  "billingPage.revoke.confirm": "Révoquer",
  "billingDetail.notFound": "Facture introuvable",
  "billingDetail.loadFailed": "Impossible de charger la facture",
  "billingDetail.notFound.body": "Cette facture n’existe pas ou n’appartient pas à votre compte.",
  "billingDetail.downloadFailed": "Échec du téléchargement",
  "billingDetail.title": "Facture {number}",
  "billingDetail.due": "Échéance le {date}",
  "billingDetail.print": "Imprimer",
  "billingDetail.payNow": "Payer maintenant",
  "billingDetail.items": "Détail",
  "billingDetail.hostingPlan": "Hébergement {plan}",
  "billingDetail.hostingId": "Hébergement n° {id}",
  "billingDetail.services": "Services",
  "billingDetail.invoiceDate": "Date de facture",
  "billingDetail.vat": "TVA",
  "billingDetail.vatPct": "TVA ({pct} %)",
  "billingDetail.pdfNote": "Le détail complet figure dans le PDF.",
  "billingDetail.billedTo": "Facturé à",
  "billingDetail.addressNote": "L’adresse de facturation complète figure sur le PDF. Une erreur\u00a0? Contactez-nous.",
  "billingDetail.history": "Historique",
  "billingDetail.hist.created": "Facture créée",
  "billingDetail.hist.overdue": "Date d’échéance dépassée",
  "billingDetail.hist.cancelled": "Facture annulée",
  "billingDetail.hist.paid": "Paiement reçu",
  "billingDetail.pay.title": "Payer la facture",
  "billingDetail.pay.cta": "Procéder au paiement",
  "billingDetail.pay.choose": "Choisissez un moyen de paiement",
  "billingDetail.method.any": "Choisir sur la page de paiement",
  "billingDetail.method.any.sub": "Tous les moyens de paiement disponibles",
  "billingDetail.method.ideal": "iDEAL",
  "billingDetail.method.ideal.sub": "Payez directement via votre banque",
  "billingDetail.method.creditcard": "Carte de crédit",
  "billingDetail.method.creditcard.sub": "Mastercard / Visa / Amex",
  "backupsPage.automatic": "Automatique",
  "backupsPage.kpi.lastSub": "dernière sauvegarde réussie",
  "backupsPage.kpi.lastNone": "aucune sauvegarde pour l’instant",
  "backupsPage.kpi.successSub": "des sauvegardes terminées ont réussi",
  "backupsPage.kpi.storageSub": "total des sauvegardes conservées",
  "backupsPage.days.one": "{n} jour",
  "backupsPage.days.other": "{n} jours",
  "backupsPage.kpi.retentionSub": "maximum",
  "backupsPage.noHostings": "Aucun hébergement trouvé.",
  "backupsPage.every": "Toutes les {h} h",
  "backupsPage.failed": "Échec",
  "backupsPage.noBackup": "Pas encore de sauvegarde",
  "backupsPage.off": "Désactivé",
  "backupsDetail.notFound": "Hébergement introuvable",
  "backupsDetail.autoOff": "Sauvegardes automatiques désactivées",
  "backupsDetail.lastFailed": "Échec de la dernière sauvegarde",
  "backupsDetail.snapshots.one": "{n} instantané",
  "backupsDetail.snapshots.other": "{n} instantanés",
  "backupsDetail.last": "dernière\u00a0: {time}",
  "backupsDetail.onlyActive": "Uniquement pour les hébergements actifs",
  "backupsDetail.running": "Sauvegarde en cours…",
  "backupsDetail.tab.schedule": "Planification",
  "backupsDetail.create.title": "Créer une sauvegarde maintenant\u00a0?",
  "backupsDetail.create.body": "La sauvegarde s’exécute en arrière-plan\u00a0; cela peut prendre quelques minutes.",
  "backupsDetail.create.cta": "Lancer la sauvegarde",
  "backupsDetail.create.done": "Sauvegarde lancée",
  "backupsDetail.restore.title": "Restaurer la sauvegarde\u00a0?",
  "backupsDetail.restore.body": "Les fichiers et la base de données actuels de {domain} seront remplacés par la sauvegarde du {date}. Cette action est irréversible.",
  "backupsDetail.restore.cta": "Restaurer",
  "backupsDetail.restore.done": "Restauration lancée",
  "backupsDetail.pickSnapshot": "Choisissez un instantané terminé à restaurer.",
  "backupsDetail.empty.title": "Aucune sauvegarde pour l’instant",
  "backupsDetail.empty.body": "La première sauvegarde automatique apparaîtra ici dès qu’elle aura été effectuée.",
  "backupsDetail.col.time": "Date et heure",
  "backupsDetail.col.keptUntil": "Conservée jusqu’au",
  "backupsDetail.type.full": "Automatique",
  "backupsDetail.type.incremental": "Incrémentielle",
  "backupsDetail.type.manual": "Manuelle",
  "backupsDetail.status.pending": "En file d’attente",
  "backupsDetail.status.running": "En cours",
  "backupsDetail.status.completed": "Terminée",
  "backupsDetail.status.failed": "Échec",
  "backupsDetail.saved": "Planification des sauvegardes enregistrée",
  "backupsDetail.auto.title": "Sauvegardes automatiques",
  "backupsDetail.auto.toggle": "Créer des sauvegardes automatiquement",
  "backupsDetail.frequency": "Fréquence",
  "backupsDetail.everyHours": "Toutes les {n} heures",
  "backupsDetail.keepFor": "Conserver",
  "backupsDetail.retention": "Durée de conservation",
  "backupsDetail.working": "En cours…",
  "dashboard.activity.verb.create": "Création\u00a0: {resource}",
  "dashboard.activity.verb.update": "Modification\u00a0: {resource}",
  "dashboard.activity.verb.delete": "Suppression\u00a0: {resource}",
  "dashboard.activity.verb.restore": "Restauration\u00a0: {resource}",
  "dashboard.activity.verb.suspend": "Suspension\u00a0: {resource}",
  "dashboard.activity.verb.unsuspend": "Réactivation\u00a0: {resource}",
  "dashboard.activity.verb.register": "Enregistrement\u00a0: {resource}",
  "dashboard.activity.verb.cancel": "Résiliation\u00a0: {resource}",
  "dashboard.activity.verb.renew": "Renouvellement\u00a0: {resource}",
  "dashboard.activity.verb.pay": "Paiement\u00a0: {resource}",
  "dashboard.activity.resource.hosting": "hébergement",
  "dashboard.activity.resource.backup": "sauvegarde",
  "dashboard.activity.resource.domain": "domaine",
  "dashboard.activity.resource.dns": "enregistrement DNS",
  "dashboard.activity.resource.email": "e-mail",
  "dashboard.activity.resource.invoice": "facture",
  "dashboard.activity.resource.payment": "paiement",
  "dashboard.activity.resource.user": "compte",
  "dashboard.activity.resource.server": "serveur",
  "dashboard.activity.resource.package": "formule",
  "domainDetail.allDomains": "Tous les domaines",
  "domainDetail.expiresIn.one": " · dans {n} jour",
  "domainDetail.expiresIn.other": " · dans {n} jours",
  "domainDetail.autoRenewState.on": "Renouvellement automatique\u00a0: activé",
  "domainDetail.autoRenewState.off": "Renouvellement automatique\u00a0: désactivé",
  "domainDetail.status.active": "Actif",
  "domainDetail.status.pending": "En cours de traitement",
  "domainDetail.status.transferring": "Transfert en cours",
  "domainDetail.status.expired": "Expiré",
  "domainDetail.status.suspended": "Suspendu",
  "domainDetail.status.unknown": "Inconnu",
  "domainDetail.registration": "Enregistrement",
  "domainDetail.autoRenew": "Renouvellement automatique",
  "domainDetail.on": "Activé",
  "domainDetail.off": "Désactivé",
  "domainDetail.nameservers": "Serveurs de noms",
  "domainDetail.linkedServices": "Services associés",
  "domainDetail.webHosting": "Hébergement web",
  "domainDetail.emailService.one": "E-mail ({n} boîte mail)",
  "domainDetail.emailService.other": "E-mail ({n} boîtes mail)",
  "domainDetail.notLinked": "Ce domaine n’est pas encore associé à un hébergement ni à un service e-mail.",
  "domainDetail.openService": "Ouvrir {name}",
  "domainDetail.dns.simpleTitle": "Que souhaitez-vous faire\u00a0?",
  "domainDetail.dns.allRecords": "Tous les enregistrements DNS",
  "domainDetail.dns.simpleSub": "Choisissez une tâche courante, nous configurons les enregistrements DNS pour vous.",
  "domainDetail.dns.advancedSub": "Vous hésitez\u00a0? Utilisez le mode simple.",
  "domainDetail.dns.mode": "Mode DNS",
  "domainDetail.dns.simple": "Simple",
  "domainDetail.dns.advanced": "Avancé",
  "domainDetail.task.website.desc": "Configurez les enregistrements A et CNAME pour que les visiteurs arrivent sur votre site.",
  "domainDetail.task.mail.title": "Mes e-mails passent par…",
  "domainDetail.task.mail.desc": "Configurez les enregistrements MX de votre fournisseur de messagerie.",
  "domainDetail.task.verify.title": "Vérifier un service",
  "domainDetail.task.verify.desc": "Ajoutez un enregistrement TXT pour prouver que vous êtes propriétaire (Google, Meta, …).",
  "domainDetail.task.forward.title": "Rediriger vers une autre URL",
  "domainDetail.task.forward.desc": "Redirigez les visiteurs de ce domaine vers une autre adresse.",
  "domainDetail.records.one": "{n} enregistrement",
  "domainDetail.records.other": "{n} enregistrements",
  "domainDetail.addRecord": "Ajouter un enregistrement",
  "domainDetail.noRecords": "Aucun enregistrement DNS pour le moment",
  "domainDetail.noRecords.sub": "Ajoutez un enregistrement ou utilisez le mode simple.",
  "domainDetail.col.type": "Type",
  "domainDetail.name": "Nom",
  "domainDetail.edit": "Modifier",
  "domainDetail.editRecord": "Modifier {type} {name}",
  "domainDetail.err.value": "Saisissez une valeur.",
  "domainDetail.err.ipv4": "Adresse IPv4 non valide.",
  "domainDetail.err.ipv6": "Adresse IPv6 non valide.",
  "domainDetail.err.hostname": "Nom d’hôte non valide.",
  "domainDetail.err.priority": "Saisissez une priorité.",
  "domainDetail.recordAdded": "Enregistrement ajouté",
  "domainDetail.recordSaved": "Enregistrement sauvegardé",
  "domainDetail.deleteRecord.title": "Supprimer l’enregistrement\u00a0?",
  "domainDetail.delete": "Supprimer",
  "domainDetail.recordDeleted": "Enregistrement supprimé",
  "domainDetail.addDnsRecord": "Ajouter un enregistrement DNS",
  "domainDetail.editDnsRecord": "Modifier l’enregistrement DNS",
  "domainDetail.propagation": "Les modifications peuvent prendre jusqu’à 1 heure pour être visibles partout.",
  "domainDetail.working": "En cours…",
  "domainDetail.typeFixed": "Le type ne peut pas être modifié.",
  "domainDetail.ttlSeconds": "TTL (secondes)",
  "domainDetail.name.hint": "Utilisez @ pour {domain}, ou p. ex. www ou mail.",
  "domainDetail.err.name": "Saisissez un nom.",
  "domainDetail.priority.hint": "Plus bas = plus important.",
  "domainDetail.replaced.one": "{n} enregistrement existant sera remplacé.",
  "domainDetail.replaced.other": "{n} enregistrements existants seront remplacés.",
  "domainDetail.website.desc": "Indiquez où votre site est hébergé. Nous configurons les bons enregistrements DNS.",
  "domainDetail.recordsApplied": "Enregistrements appliqués",
  "domainDetail.website.where": "Où votre site est-il hébergé\u00a0?",
  "domainDetail.website.ip": "Une adresse IP",
  "domainDetail.website.ip.sub": "Votre hébergeur vous fournit une adresse IPv4.",
  "domainDetail.website.host": "Un nom d’hôte (p. ex. monsite.netlify.app)",
  "domainDetail.website.host.sub": "Pour des services comme Netlify, Vercel ou Shopify. S’applique à www.",
  "domainDetail.ipAddress": "Adresse IP",
  "domainDetail.hostname": "Nom d’hôte",
  "domainDetail.preview.set": "Nous allons créer ces enregistrements\u00a0:",
  "domainDetail.mail.ours": "Notre service e-mail",
  "domainDetail.mail.ours.desc": "Vous gérez les boîtes mail ici, dans le portail ({n} actives).",
  "domainDetail.mail.google.desc": "Gmail pour votre domaine. Nécessite un compte Workspace.",
  "domainDetail.mail.ms.desc": "Outlook pour votre domaine. Nécessite un compte Microsoft 365.",
  "domainDetail.mail.custom": "Autre fournisseur",
  "domainDetail.mail.custom.desc": "Saisissez le serveur de messagerie de votre fournisseur.",
  "domainDetail.mail.none": "Pas d’e-mail",
  "domainDetail.mail.none.desc": "Pas d’e-mail sur ce domaine. Supprime les enregistrements MX.",
  "domainDetail.mail.desc": "Choisissez votre fournisseur de messagerie. Nous remplaçons les enregistrements MX.",
  "domainDetail.mail.cta": "Remplacer les enregistrements MX",
  "domainDetail.mail.applied": "Enregistrements MX appliqués",
  "domainDetail.mail.provider": "Fournisseur de messagerie",
  "domainDetail.mail.server": "Serveur de messagerie",
  "domainDetail.preview.mxRemoved": "Tous les enregistrements MX seront supprimés.",
  "domainDetail.verify.desc": "De nombreux services demandent un enregistrement TXT pour prouver que ce domaine vous appartient.",
  "domainDetail.verify.cta": "Créer l’enregistrement TXT",
  "domainDetail.verify.created": "Enregistrement TXT créé",
  "domainDetail.verify.code": "Code de vérification",
  "domainDetail.verify.code.hint": "Commence généralement par p. ex. google-site-verification=",
  "domainDetail.preview.create": "Nous allons créer cet enregistrement\u00a0:",
  "domainDetail.redirect.desc": "Les visiteurs sont automatiquement redirigés vers l’adresse que vous indiquez.",
  "domainDetail.create": "Créer",
  "domainDetail.redirect.created": "Redirection créée",
  "domainDetail.redirect.from": "De",
  "domainDetail.redirect.from.hint": "@ pour {domain}, ou un sous-domaine comme shop.",
  "domainDetail.redirect.from.err": "Utilisez @ ou un sous-domaine valide.",
  "domainDetail.redirect.to": "Vers (URL complète)",
  "domainDetail.redirect.to.err": "Saisissez une URL complète commençant par https://",
  "domainDetail.redirect.type": "Type de redirection",
  "domainDetail.redirect.301": "301 — permanente",
  "domainDetail.redirect.302": "302 — temporaire",
  "domainDetail.redirect.keepPath": "Conserver le chemin (/page → cible/page)",
  "domainDetail.routing.title": "Routage actuel des e-mails",
  "domainDetail.routing.change": "Changer de fournisseur",
  "domainDetail.routing.none": "Aucun e-mail configuré",
  "domainDetail.routing.noMx": "Il n’y a aucun enregistrement MX pour ce domaine.",
  "domainDetail.deliverability": "Délivrabilité",
  "domainDetail.spf.missing": "Aucun enregistrement SPF trouvé. Vos e-mails risquent d’être considérés comme spam.",
  "domainDetail.dkim.missing": "Aucun enregistrement DKIM trouvé.",
  "domainDetail.dmarc.policy": "Politique\u00a0: {policy}",
  "domainDetail.dmarc.missing": "Aucun enregistrement DMARC trouvé. Recommandé\u00a0: p=quarantine.",
  "domainDetail.forwards": "Redirections",
  "domainDetail.add": "Ajouter",
  "domainDetail.forwards.empty": "Aucune redirection",
  "domainDetail.forwards.empty.sub": "Redirigez ce domaine (ou l’un de ses sous-domaines) vers une autre adresse.",
  "domainDetail.forward.temporary": "Temporaire",
  "domainDetail.forward.permanent": "Permanente",
  "domainDetail.forward.frame": "Cadre",
  "domainDetail.forward.delete": "Supprimer la redirection {from}",
  "domainDetail.forward.delete.title": "Supprimer la redirection\u00a0?",
  "domainDetail.forward.deleted": "Redirection supprimée",
  "domainDetail.ns.saved": "Serveurs de noms enregistrés",
  "domainDetail.ns.desc": "Les serveurs de noms déterminent qui gère le DNS de ce domaine. Choisissez nos serveurs de noms (nous gérons la zone) ou les vôtres.",
  "domainDetail.ns.label": "Serveur de noms {n}",
  "domainDetail.ns.invalid": "Au moins un serveur de noms n’est pas un nom d’hôte valide.",
  "domainDetail.dnssec.enabled": "DNSSEC activé",
  "domainDetail.dnssec.disabled": "DNSSEC désactivé",
  "domainDetail.dnssec.desc": "DNSSEC signe cryptographiquement les réponses DNS. Recommandé pour les domaines en production.",
  "domainDetail.dnssec.changed": "Modifié le {date}",
  "topbar.search.goToPage": "Aller à la page",
  "topbar.search.action": "Action",
  "topbar.action.addDomain": "Ajouter un domaine",
  "topbar.action.createMailbox": "Créer une boîte mail",
  "topbar.action.addDnsRecord": "Ajouter un enregistrement DNS",
  "topbar.action.restoreBackup": "Restaurer une sauvegarde",
  "topbar.action.newPlan": "Nouvelle formule d’hébergement",
  "topbar.action.openInvoices": "Factures en attente",
  "topbar.menu.open": "Ouvrir le menu",
  "topbar.menu.close": "Fermer le menu",
  "topbar.menu.label": "Menu",
  "topbar.menu.main": "Menu principal",
  "topbar.search.title": "Rechercher (⌘K)",
  "topbar.search.label": "Rechercher",
  "topbar.search.placeholder": "Rechercher…",
  "topbar.search.pages": "Pages",
  "topbar.search.actions": "Actions",
  "topbar.search.inputLabel": "Rechercher une page ou une action",
  "topbar.search.inputPlaceholder": "Rechercher une page ou une action…",
  "topbar.search.noResults": "Aucun résultat pour «\u00a0{q}\u00a0»",
  "topbar.search.navigate": "naviguer",
  "topbar.search.open": "ouvrir",
  "topbar.search.close": "fermer",
  "topbar.notif.title": "Notifications",
  "topbar.notif.labelUnread": "Notifications, {n} non lues",
  "topbar.notif.unread": "{n} non lues",
  "topbar.notif.allCaughtUp": "Vous êtes à jour",
  "topbar.notif.markAllRead": "Tout marquer comme lu",
  "topbar.notif.loadError": "Impossible de charger les notifications.",
  "topbar.notif.empty": "Aucune notification",
  "topbar.theme.toggle": "Changer de thème",
  "topbar.user.menu": "Menu du compte",
  "topbar.user.idCopied": "Numéro client copié",
  "topbar.user.customer": "Client",
  "topbar.user.copy": "Copier",
  "topbar.user.copyId": "Copier le numéro client",
  "topbar.user.darkTheme": "Thème sombre",
  "account.title": "Mon compte",
  "account.working": "En cours…",
  "account.close": "Fermer",
  "account.change": "Modifier",
  "account.enable": "Activer",
  "account.disable": "Désactiver",
  "account.continue": "Continuer",
  "account.copied": "Copié",
  "account.password": "Mot de passe",
  "account.currentPassword": "Mot de passe actuel",
  "account.logout.menu": "Se déconnecter",
  "account.logout.title": "Se déconnecter\u00a0?",
  "account.logout.body": "Vous serez déconnecté sur cet appareil. Les clients de messagerie connectés et les sessions SSH restent actifs.",
  "account.logout.cta": "Oui, me déconnecter",
  "account.logout.done": "Vous avez été déconnecté",
  "account.profile.saved": "Profil enregistré",
  "account.profile.fullName": "Nom complet",
  "account.profile.email": "Adresse e-mail",
  "account.profile.currentPasswordHint": "Nécessaire pour modifier votre adresse e-mail.",
  "account.security.title": "Sécurité et 2FA",
  "account.security.description": "Gérez votre mot de passe et l’authentification à deux facteurs.",
  "account.security.passwordSub": "Modifiez le mot de passe avec lequel vous vous connectez.",
  "account.security.mfa": "Authentification à deux facteurs",
  "account.security.mfaActive": "Active — application d’authentification",
  "account.security.mfaOff": "Non activée",
  "account.password.min": "Au moins {n} caractères.",
  "account.password.mismatch": "Les mots de passe ne correspondent pas.",
  "account.password.changed": "Mot de passe modifié",
  "account.password.wrongCurrent": "Votre mot de passe actuel est incorrect.",
  "account.password.changeTitle": "Modifier le mot de passe",
  "account.password.new": "Nouveau mot de passe",
  "account.password.confirm": "Confirmez le nouveau mot de passe",
  "account.mfa.enabledTitle": "La 2FA est activée",
  "account.mfa.recoveryBody": "Conservez ces codes de récupération en lieu sûr. Chaque code fonctionne une seule fois si vous n’avez pas votre téléphone sous la main.",
  "account.mfa.saved": "Je les ai conservés",
  "account.mfa.enableTitle": "Activer l’authentification à deux facteurs",
  "account.mfa.setupBody": "Ajoutez ce compte à votre application d’authentification (p. ex. 1Password, Google Authenticator) avec la clé ci-dessous, puis saisissez le code à 6 chiffres.",
  "account.mfa.introBody": "Une fois activée, la connexion vous demandera aussi un code de votre application d’authentification.",
  "account.mfa.key": "Clé",
  "account.mfa.openInApp": "Ouvrir dans l’application d’authentification",
  "account.mfa.copyKey": "Copier la clé",
  "account.mfa.codeFromApp": "Code de l’application",
  "account.mfa.disabled": "2FA désactivée",
  "account.mfa.disableTitle": "Désactiver l’authentification à deux facteurs",
  "account.mfa.disableBody": "Confirmez avec un code de votre application d’authentification.",
  "account.mfa.code": "Code",
  "login.title": "Bon retour parmi nous",
  "login.subtitle": "Connectez-vous pour gérer votre hébergement, vos domaines et vos e-mails.",
  "login.mfaCode": "Code de votre application d’authentification",
  "login.back": "Retour",
  "login.submit": "Se connecter",
  "login.noAccount": "Pas encore de compte\u00a0? Contactez-nous.",
  "dashboard.mailboxCount.one": "{n} boîte mail",
  "dashboard.mailboxCount.other": "{n} boîtes mail",
  "addDomain.description.check": "Vérifiez si votre domaine est disponible et enregistrez-le aussitôt.",
  "addDomain.checking": "Vérification…",
  "addDomain.prices": "Prix par an\u00a0: {list}",
  "addDomain.term.years.one": "{n} an, puis renouvelé chaque année",
  "addDomain.term.years.other": "{n} ans, puis renouvelé chaque année",
  "addDomain.cost.price": "{amount}, sur votre prochaine facture",
  "addDomain.renew": "Renouvellement",
  "addDomain.renew.price": "{amount} par an",
  "addDomain.status.registered": "{domain} est déjà enregistré. Essayez un autre nom ou une autre extension.",
  "addDomain.status.reserved": "{domain} est réservé et ne peut pas être enregistré.",
  "addDomain.status.premium": "{domain} est un domaine premium. Contactez-nous pour connaître les possibilités.",
  "addDomain.status.invalid": "Ce nom de domaine n’est pas valide.",
  "addDomain.status.unsupported_tld": "Nous ne proposons pas (encore) cette extension.",
  "addDomain.status.unknown": "Impossible de déterminer si {domain} est disponible. Veuillez réessayer plus tard.",
  "login.forgot": "Mot de passe oublié\u00a0?",
  "public.toLogin": "Aller à la connexion",
  "public.missingToken": "Ce lien est incomplet. Ouvrez à nouveau le lien de l’e-mail ou copiez-le en entier.",
  "public.password.new": "Nouveau mot de passe",
  "public.password.repeat": "Confirmer le mot de passe",
  "public.password.hint": "Au moins {n} caractères.",
  "public.password.tooShort": "Votre mot de passe doit contenir au moins {n} caractères.",
  "public.password.mismatch": "Les mots de passe ne correspondent pas.",
  "verify.title": "Confirmer l’adresse e-mail",
  "verify.busy": "Confirmation de votre adresse e-mail…",
  "verify.ok": "Votre adresse e-mail est confirmée. Vous pouvez maintenant vous connecter.",
  "verify.invalid": "Ce lien de confirmation n’est pas valide ou a déjà été utilisé. Si votre adresse est déjà confirmée, vous pouvez simplement vous connecter.",
  "reset.request.title": "Mot de passe oublié",
  "reset.request.sub": "Saisissez votre adresse e-mail. Nous vous enverrons un lien pour définir un nouveau mot de passe.",
  "reset.request.submit": "Envoyer le lien",
  "reset.request.sent": "Si un compte existe pour {email}, vous recevrez un lien dans quelques minutes. Le lien est valable 1 heure.",
  "reset.title": "Définir un nouveau mot de passe",
  "reset.sub": "Choisissez un nouveau mot de passe pour votre compte.",
  "reset.submit": "Enregistrer le mot de passe",
  "reset.done": "Votre mot de passe a été modifié. Connectez-vous avec votre nouveau mot de passe.",
  "reset.invalid": "Ce lien n’est pas valide ou a expiré. Demandez-en un nouveau.",
  "reset.requestNew": "Demander un nouveau lien",
  "invite.title": "Accepter l’invitation",
  "invite.sub": "Vous avez été invité à DMRS Console. Saisissez votre nom et choisissez un mot de passe pour créer votre compte.",
  "invite.name": "Nom complet",
  "invite.submit": "Créer le compte",
  "invite.done": "Votre compte a été créé. Vous pouvez maintenant vous connecter.",
  "invite.done.email": "Votre compte a été créé. Connectez-vous avec {email} et votre nouveau mot de passe.",
  "invite.invalid": "Cette invitation n’est pas valide ou a déjà été utilisée.",
  "invite.expired": "Cette invitation a expiré. Demandez-en une nouvelle à la personne qui vous a invité.",
  "invite.registered": "Un compte existe déjà pour cette adresse e-mail. Connectez-vous ou réinitialisez votre mot de passe.",

  "addDomain.order.title": "Commander {domain}",
  "addDomain.order.description": "Vous payez via Mollie. Après le paiement, nous enregistrons le domaine au nom du titulaire ci-dessous.",
  "addDomain.pricePerYear": "Prix par an",
  "addDomain.period.one": "{n} an",
  "addDomain.period.other": "{n} ans",
  "addDomain.period.price.one": "{n} an · {amount}",
  "addDomain.period.price.other": "{n} ans · {amount}",
  "addDomain.vatNote": "Prix hors TVA de 21\u00a0%.",
  "addDomain.pay": "Commander et payer",
  "addDomain.redirecting": "Vers le paiement…",
  "addDomain.registered.title": "{domain} est déjà enregistré",
  "addDomain.registered.description": "Ce domaine vous appartient\u00a0? Associez-le à votre compte ou transférez-le chez nous.",
  "addDomain.choice.link": "Il m’appartient\u00a0: l’associer",
  "addDomain.choice.link.sub": "Gratuit. L’enregistrement reste chez votre fournisseur actuel.",
  "addDomain.choice.transfer": "Le transférer chez nous",
  "addDomain.choice.transfer.sub": "{amount} HT. Vous avez besoin du code de transfert de votre fournisseur actuel.",
  "addDomain.choice.transfer.unpriced": "Vous avez besoin du code de transfert de votre fournisseur actuel.",
  "addDomain.link": "Associer le domaine",
  "addDomain.linked": "{domain} a été associé",
  "addDomain.authCode": "Code de transfert (code EPP)",
  "addDomain.authCode.hint": "Demandez ce code à votre fournisseur actuel.",
  "registrant.title": "Titulaire du domaine",
  "registrant.hint": "Ces informations sont enregistrées auprès du registre.",
  "registrant.name": "Nom",
  "registrant.company": "Société (facultatif)",
  "registrant.address": "Adresse",
  "registrant.postalCode": "Code postal",
  "registrant.city": "Ville",
  "registrant.country": "Pays",
  "registrant.phone": "Téléphone",
  "registrant.phone.hint": "Par exemple +33 6 12 34 56 78",
  "registrant.email": "E-mail",
  "order.err.required": "Veuillez remplir ce champ.",
  "order.err.invalid": "Veuillez vérifier ce champ.",
  "order.err.fields": "Veuillez vérifier les champs signalés.",
  "order.err.notRegistered": "{domain} n’est pas enregistré et ne peut donc pas être transféré. Enregistrez-le plutôt.",
  "order.err.alreadyManaged": "{domain} est déjà enregistré chez nous.",
  "order.err.orderExists": "Une commande est déjà en cours pour {domain}. Vous la trouverez sur la page des domaines.",
  "order.err.paymentFailed": "La commande a été créée, mais le paiement n’a pas pu démarrer. Veuillez réessayer plus tard depuis la page des domaines.",
  "order.err.priceUnavailable": "Cette extension n’a pas encore de prix et ne peut pas être commandée pour le moment. Veuillez nous contacter.",
  "orders.title": "Commandes de domaines",
  "orders.checking": "Récupération du statut de votre commande…",
  "orders.pay": "Payer",
  "orders.details": "Message technique",
  "orders.error.invalid_auth_code": "Le code de transfert (EPP) a été refusé. Demandez un nouveau code à votre fournisseur actuel et réessayez.",
  "orders.error.domain_unavailable": "Ce domaine n'est pas (ou plus) disponible à l'enregistrement.",
  "orders.error.transfer_refused": "Le registraire actuel ou le registre a refusé le transfert. Vérifiez que le domaine est déverrouillé.",
  "orders.error.contact_invalid": "Les coordonnées du titulaire n'ont pas été acceptées. Vérifiez l'adresse et le numéro de téléphone.",
  "orders.error.price_unavailable": "Aucun prix n'est disponible pour cette extension pour le moment.",
  "orders.error.provider_error": "Le registraire n'a pas pu traiter la commande. Notre équipe est prévenue et vous contactera.",
  "orders.err.notPayable": "Cette commande ne peut plus être payée.",
  "orders.action.register": "Enregistrement",
  "orders.action.transfer": "Transfert",
  "orders.status.pending": "En attente de paiement",
  "orders.status.paid": "Payée",
  "orders.status.provisioning": "En cours",
  "orders.status.completed": "Terminée",
  "orders.status.failed": "Échec",
  "orders.status.cancelled": "Annulée",
  "orders.msg.pending": "Nous n’avons pas encore reçu votre paiement.",
  "orders.msg.provisioning.register": "Paiement reçu. Nous enregistrons le domaine.",
  "orders.msg.provisioning.transfer": "Paiement reçu. Nous demandons le transfert.",
  "orders.msg.completed.register": "{domain} est enregistré et figure dans votre liste.",
  "orders.msg.completed.transfer": "Le transfert de {domain} a été demandé. Cela peut prendre quelques jours.",
  "orders.msg.failed": "Le traitement de {domain} a échoué. Nous sommes informés et vous contacterons.",
  "domainDetail.ns.modeDefault": "Par défaut",
  "domainDetail.ns.modeOwn": "Mes serveurs de noms",
  "domainDetail.ns.ownDesc": "Au moins deux. Avec vos propres serveurs de noms, vous gérez le DNS chez votre propre fournisseur ; les enregistrements d'ici ne sont alors plus utilisés.",
  "domainDetail.ns.defaultExplain": "Nous gérons la zone et configurons les serveurs de noms chez le registraire. Vos enregistrements sont prêts avant.",
  "domainDetail.ns.registrarPicks": "La zone est chez notre registraire, qui choisit lui-même les serveurs de noms.",
  "domainDetail.ns.source.own": "Indiqués par vous",
  "domainDetail.ns.source.package": "Inclus dans votre formule",
  "domainDetail.ns.source.global": "Nos serveurs de noms par défaut",
  "domainDetail.ns.source.bunny": "Nos serveurs de noms par défaut",
  "domainDetail.ns.source.registrar": "Choisis par le registraire",
  "domainDetail.ns.state.ok": "Configurés chez le registraire",
  "domainDetail.ns.state.pending": "En cours de configuration chez le registraire",
  "domainDetail.ns.state.other": "Configurez-les chez votre registraire",
  "domainDetail.dnssec.enabledPending": "DNSSEC activé ; la clé est en cours d'ajout au registre",
  "domainDetail.dnssec.state.off": "DNSSEC est désactivé.",
  "domainDetail.dnssec.state.on": "La zone est signée et sa clé est au registre.",
  "domainDetail.dnssec.state.pending": "La zone est signée. La clé est ajoutée au registre dès que possible.",
  "domainDetail.dnssec.state.copyDs": "La zone est signée. Ajoutez cet enregistrement DS chez le registraire de votre domaine :",
  "domainDetail.dnssec.legacyZone": "Cette zone est toujours signée automatiquement.",
  "domainDetail.dnssec.ownNameservers": "Avec vos propres serveurs de noms, DNSSEC est géré par votre fournisseur DNS.",
  "addDomain.prestage": "Préparer seulement",
  "addDomain.prestage.hint": "Préparer : configurez le DNS dès maintenant et commandez l'enregistrement plus tard. Le domaine fonctionne alors immédiatement.",
  "addDomain.prestaged": "{domain} est préparé. Configurez le DNS et commandez l'enregistrement quand vous voulez.",
};
